// const defaultMock = {
//     order: {
//         id: 1609,
//         foreignName: "12345-AB",
//     },
//     orderItems: [{}],
//     statusEvents: [
//         {
//             type: "ORDER_BOOKED",
//             status: "DONE",
//         },
//         {
//             type: "BOOKING_SHIPMENTS",
//             status: "NOT_DONE",
//             trackingReference: "1111-2222-3333-4444",
//             pickupTime: "2021-06-04",
//         },
//     ],
// };
// export default defaultMock;

import { RETURN_STATUS_EVENTS } from "rylak-common/src/constants";

const defaultMock = {
    order: {
        id: 1609,
        foreignName: "12345-AB",
    },
    orderItems: [{}],
    statusEvents: [
        {
            type: RETURN_STATUS_EVENTS.RETURN_CREATED,
            status: "DONE",
        },
        {
            type: RETURN_STATUS_EVENTS.COMPLAINT_PENDING,
            status: "DONE",
        },
        {
            type: RETURN_STATUS_EVENTS.COMPLAINT_DENIED,
            responseText: "Du skrev i reklamationen att du valde fel färg. Detta är inte butikens fel och vi kan därför inte reklamera din produkt.",
            status: "DONE",
        },
        {
            type: RETURN_STATUS_EVENTS.BOOKING_SHIPMENTS,
            status: "DONE",
        },
        // {
        //     type: "ORDER_RESALE",
        //     status: "DONE",
        // },
        {
            type: RETURN_STATUS_EVENTS.PACK_ITEMS_LOCKER,
            status: "DONE",
            trackingReference: "1111-2222-3333-4444",
            // trackingUrl: "todo",
        },
        {
            type: RETURN_STATUS_EVENTS.PACK_ITEMS_LOCKER,
            status: "DONE",
            trackingReference: "1111-2222-3333-4444",
            trackingUrl: "todo",
        },
        {
            type: RETURN_STATUS_EVENTS.PACK_ITEMS_PRINT_LABEL,
            status: "DONE",
        },
        {
            type: RETURN_STATUS_EVENTS.PACK_ITEMS_PRINT_LABEL,
            printDocuments: true,
            customsType: "NO_CUSTOMS",
            status: "DONE",
        },
        {
            type: RETURN_STATUS_EVENTS.PACK_ITEMS_PRINT_LABEL,
            qrCodeData: "134124314", //shipping number
            printDocuments: true,
            customsType: "NO_CUSTOMS",
            status: "DONE",
        },
        {
            type: RETURN_STATUS_EVENTS.PACK_ITEMS_PRINT_LABEL,
            qrCodeData: "123253423",
            printDocuments: false,
            customsType: "NO_CUSTOMS",
            status: "DONE",
            documentsHandledExternally: true,
        },
        {
            type: RETURN_STATUS_EVENTS.PACK_ITEMS_PRINT_LABEL,
            printDocuments: true,
            customsType: "PLT",
            status: "DONE",
        },
        {
            type: RETURN_STATUS_EVENTS.PACK_ITEMS_PRINT_LABEL,
            printDocuments: true,
            customsType: "CUSTOMS",
            status: "DONE",
        },
        {
            type: RETURN_STATUS_EVENTS.PACK_ITEMS_RETURN_SLIP,
            status: "DONE",
        },
        {
            type: RETURN_STATUS_EVENTS.PACK_ITEMS_CUSTOMER_BOOKS_SHIPMENT,
            returnAddress: {
                firstName: "Demo",
                lastName: "Returns",
                attentionName: "US Customer Service",
                street: "1 Warehouse Road",
                street2: "Suite 200",
                zip: "10001",
                city: "New York",
                provinceCode: "NY",
                countryCode: "US",
            },
            status: "DONE",
        },
        {
            type: RETURN_STATUS_EVENTS.PACK_ITEMS_PICKUP,
            status: "DONE",
            trackingReference: "1111-2222-3333-4444",
            pickupTime: "2021-06-04",
        },
        // {
        //     type: "PACKING_BAG_DELIVERY",
        //     status: "DONE",
        //     deliveryTime: "2021-06-05",
        // },
        // {
        //     type: "PACK_ITEMS",
        //     status: "DONE",
        //     trackingReference: "1111-2222-3333-4444",
        //     pickupTime: "2021-06-04",
        // },
        {
            type: RETURN_STATUS_EVENTS.RETURN_IN_TRANSIT,
            status: "DONE",
        },
        {
            type: RETURN_STATUS_EVENTS.QUALITY_CONTROL_PENDING,
            status: "DONE",
        },
        {
            type: RETURN_STATUS_EVENTS.RETURN_COMPLETED,
            status: "DONE",
        },
        {
            type: RETURN_STATUS_EVENTS.RETURN_CANCELLED,
            status: "DONE",
        },
        {
            type: "THIS_TYPE_DOES_NOT_EXIST",
            status: "NOT_DONE",
        },
    ],
};

export function getOrderStatusMock({ brandName }) {
    if (brandName === "cos") {
        return {
            order: {
                id: 131913,
                entityAddress: {
                    id: 316854,
                    street: "Testgatan 1",
                    streetFull: "Testgatan 1",
                    city: "Testcity",
                    countryCode: "SE",
                    zip: "111 11",
                    firstName: "Linus",
                    lastName: "Robertsson",
                    fullName: "Linus Robertsson",
                    email: "linus@turnr.se",
                    phone: "0705320897",
                    createdAt: "2023-11-27T21:40:35.860940Z",
                },
                merchantBrand: {
                    id: 626,
                    name: "cos",
                    shopType: "CENTRA",
                    shopStatus: "ACTIVE",
                    nextUpdateAt: "2023-11-28T18:54:07.985724Z",
                    fontNamePrimary: "Inter",
                    backgroundImage: "https://i.pinimg.com/originals/84/2a/d6/842ad68b315b0f586c30b465221da609.jpg",
                    backgroundImageOpacity: 100,
                    backgroundImageBlur: 3,
                    logoSrc: "https://upload.wikimedia.org/wikipedia/commons/6/6e/COS_Logo.png",
                    logoHeight: 24,
                    colorPrimary: "#000000",
                    colorSecondary: "#ededed",
                    resaleTitlePostfix: "- Returned product",
                    resaleTextPostfix:
                        "This product will be shipped directly from another customer that has chosen to return the product. It is a good choice for the environment and as a bonus you get a discount!",
                    orderIdText: "ORDER_NUMBER",
                    displayName: "COS",
                    htmlPageTitle: "COS Return Portal",
                    htmlFavicon: "https://storage.googleapis.com/turnr-public/favicon-57%20(1).png",
                    defaultLanguage: "EN",
                    enabledLanguages: ["EN"],
                    productsBundleMock: "COS",
                    activePaymentPlan: {
                        id: 585,
                    },
                    createdAt: "2023-11-16T16:46:06.590992Z",
                    fontSizeBody: "14px",
                    fontWeightBody: "normal",
                    currency: "SEK",
                    exchangePolicy: "EXCHANGE_ON_RETURN",
                    roleSupportExchangeHandlingPermission: true,
                    roleSupportRefundHandlingPermission: true,
                    buttonType: "SHARP",
                    inputType: "SHARP",
                    checkboxType: "SHARP",
                    windowType: "SHARP",
                    overallType: "SHARP",
                    riskSystemEnabled: false,
                    riskSystemCustomerScoreWeight: 1,
                    riskSystemOrderCapitalWeight: 1,
                    riskSystemChainedOrdersWeight: 1,
                    statistics: {
                        TOTAL: {
                            orders: 16,
                            orderItems: 69,
                            ordersWorth: 986892.45,
                            returns: 12,
                            returnsTurnr: 8,
                            returnItems: 974,
                            returnItemsWorth: 817122.39,
                            returnItemsTurnr: 33,
                            returnItemsTurnrWorth: 20805.69,
                            exchangeItems: 9,
                            exchangeItemsWorth: 4025.68,
                            resalesAttempted: 0,
                            resalesAttemptedWorth: 0,
                            resalesCompleted: 0,
                            resalesCompletedWorth: 0,
                            complaintItems: 4,
                            complaintItemsWorth: 3226.42,
                            refundTransactions: 0,
                            refundTransactionsWorth: 0,
                            refundTransactionsTurnr: 0,
                            refundTransactionsTurnrWorth: 0,
                            giftCardsCreated: 0,
                            giftCardsCreatedWorth: 0,
                        },
                        LAST_3_MONTHS: {
                            orders: 16,
                            orderItems: 69,
                            ordersWorth: 986892.45,
                            returns: 12,
                            returnsTurnr: 8,
                            returnItems: 974,
                            returnItemsWorth: 817122.39,
                            returnItemsTurnr: 33,
                            returnItemsTurnrWorth: 20805.69,
                            exchangeItems: 9,
                            exchangeItemsWorth: 4025.68,
                            resalesAttempted: 0,
                            resalesAttemptedWorth: 0,
                            resalesCompleted: 0,
                            resalesCompletedWorth: 0,
                            complaintItems: 4,
                            complaintItemsWorth: 3226.42,
                            refundTransactions: 0,
                            refundTransactionsWorth: 0,
                            refundTransactionsTurnr: 0,
                            refundTransactionsTurnrWorth: 0,
                            giftCardsCreated: 0,
                            giftCardsCreatedWorth: 0,
                        },
                    },
                    entityType: "SHOP",
                    workerInfo: {
                        worker: "SHOP_UPDATER",
                        status: "READY",
                        startedAt: "2023-11-27T18:54:06.955503Z",
                        endedAt: "2023-11-27T18:54:07.985745Z",
                        failedAttempts: 0,
                    },
                    entityId: 626,
                },
                foreignId: "e2c7111336a18af4049adad7b1034330",
                foreignNumber: 695,
                foreignMarketId: "5-25",
                createdAt: "2023-11-27T21:40:35.864454Z",
                shopOrderCreatedAt: "2023-11-27T21:37:13Z",
                shopOrderFulfilledAt: "2023-11-27T21:37:28Z",
                currencyCode: "DKK",
                currencyCodeCustomer: "SEK",
                shippingCost: 31.94,
                shippingCostCustomer: 49,
                totalAmount: 1557.15,
                totalAmountCustomer: 2389,
                totalDiscount: 0,
                totalDiscountCustomer: 0,
                conditionedDiscount: 0,
                conditionedDiscountCustomer: 0,
                amountPaidWithGiftCard: 0,
                amountPaidWithGiftCardCustomer: 0,
                taxesAmount: 311.43,
                taxesAmountCustomer: 477.8,
                customer: {
                    id: 85281,
                    email: "linus@turnr.se",
                    riskScore: 50,
                    blacklisted: false,
                    firstName: "Linus",
                    lastName: "Robertsson",
                    riskLevel: "NORMAL",
                    entityType: "CUSTOMER",
                    workerInfo: {
                        status: "READY",
                        failedAttempts: 0,
                    },
                    entityId: 85281,
                },
                returns: null,
                entityType: "ORDER",
                workerInfo: {
                    status: "READY",
                    failedAttempts: 0,
                },
                entityId: 131913,
            },
            returns: [
                {
                    returnId: 133180,
                    createdAt: "2023-11-27T21:40:35.871418Z",
                    carrier: "POSTNORD",
                    languageCode: "EN",
                    orderItems: [
                        {
                            id: 223375,
                            foreignLineItemId: "1083",
                            order: {
                                id: 131913,
                                entityAddress: {
                                    id: 316854,
                                    street: "Testgatan 1",
                                    streetFull: "Testgatan 1",
                                    city: "Testcity",
                                    countryCode: "SE",
                                    zip: "111 11",
                                    firstName: "Linus",
                                    lastName: "Robertsson",
                                    fullName: "Linus Robertsson",
                                    email: "linus@turnr.se",
                                    phone: "0705320897",
                                    createdAt: "2023-11-27T21:40:35.860940Z",
                                },
                                merchantBrand: {
                                    id: 626,
                                    name: "cos",
                                    shopType: "CENTRA",
                                    shopStatus: "ACTIVE",
                                    nextUpdateAt: "2023-11-28T18:54:07.985724Z",
                                    fontNamePrimary: "Inter",
                                    backgroundImage: "https://i.pinimg.com/originals/84/2a/d6/842ad68b315b0f586c30b465221da609.jpg",
                                    backgroundImageOpacity: 100,
                                    backgroundImageBlur: 3,
                                    logoSrc: "https://upload.wikimedia.org/wikipedia/commons/6/6e/COS_Logo.png",
                                    logoHeight: 24,
                                    colorPrimary: "#000000",
                                    colorSecondary: "#ededed",
                                    resaleTitlePostfix: "- Returned product",
                                    resaleTextPostfix:
                                        "This product will be shipped directly from another customer that has chosen to return the product. It is a good choice for the environment and as a bonus you get a discount!",
                                    orderIdText: "ORDER_NUMBER",
                                    displayName: "COS",
                                    htmlPageTitle: "COS Return Portal",
                                    htmlFavicon: "https://storage.googleapis.com/turnr-public/favicon-57%20(1).png",
                                    defaultLanguage: "EN",
                                    enabledLanguages: ["EN"],
                                    productsBundleMock: "COS",
                                    activePaymentPlan: {
                                        id: 585,
                                    },
                                    createdAt: "2023-11-16T16:46:06.590992Z",
                                    fontSizeBody: "14px",
                                    fontWeightBody: "normal",
                                    currency: "SEK",
                                    exchangePolicy: "EXCHANGE_ON_RETURN",
                                    roleSupportExchangeHandlingPermission: true,
                                    roleSupportRefundHandlingPermission: true,
                                    buttonType: "SHARP",
                                    inputType: "SHARP",
                                    checkboxType: "SHARP",
                                    windowType: "SHARP",
                                    overallType: "SHARP",
                                    riskSystemEnabled: false,
                                    riskSystemCustomerScoreWeight: 1,
                                    riskSystemOrderCapitalWeight: 1,
                                    riskSystemChainedOrdersWeight: 1,
                                    statistics: {
                                        TOTAL: {
                                            orders: 16,
                                            orderItems: 69,
                                            ordersWorth: 986892.45,
                                            returns: 12,
                                            returnsTurnr: 8,
                                            returnItems: 974,
                                            returnItemsWorth: 817122.39,
                                            returnItemsTurnr: 33,
                                            returnItemsTurnrWorth: 20805.69,
                                            exchangeItems: 9,
                                            exchangeItemsWorth: 4025.68,
                                            resalesAttempted: 0,
                                            resalesAttemptedWorth: 0,
                                            resalesCompleted: 0,
                                            resalesCompletedWorth: 0,
                                            complaintItems: 4,
                                            complaintItemsWorth: 3226.42,
                                            refundTransactions: 0,
                                            refundTransactionsWorth: 0,
                                            refundTransactionsTurnr: 0,
                                            refundTransactionsTurnrWorth: 0,
                                            giftCardsCreated: 0,
                                            giftCardsCreatedWorth: 0,
                                        },
                                        LAST_3_MONTHS: {
                                            orders: 16,
                                            orderItems: 69,
                                            ordersWorth: 986892.45,
                                            returns: 12,
                                            returnsTurnr: 8,
                                            returnItems: 974,
                                            returnItemsWorth: 817122.39,
                                            returnItemsTurnr: 33,
                                            returnItemsTurnrWorth: 20805.69,
                                            exchangeItems: 9,
                                            exchangeItemsWorth: 4025.68,
                                            resalesAttempted: 0,
                                            resalesAttemptedWorth: 0,
                                            resalesCompleted: 0,
                                            resalesCompletedWorth: 0,
                                            complaintItems: 4,
                                            complaintItemsWorth: 3226.42,
                                            refundTransactions: 0,
                                            refundTransactionsWorth: 0,
                                            refundTransactionsTurnr: 0,
                                            refundTransactionsTurnrWorth: 0,
                                            giftCardsCreated: 0,
                                            giftCardsCreatedWorth: 0,
                                        },
                                    },
                                    entityType: "SHOP",
                                    workerInfo: {
                                        worker: "SHOP_UPDATER",
                                        status: "READY",
                                        startedAt: "2023-11-27T18:54:06.955503Z",
                                        endedAt: "2023-11-27T18:54:07.985745Z",
                                        failedAttempts: 0,
                                    },
                                    entityId: 626,
                                },
                                foreignId: "e2c7111336a18af4049adad7b1034330",
                                foreignNumber: 695,
                                foreignMarketId: "5-25",
                                createdAt: "2023-11-27T21:40:35.864454Z",
                                shopOrderCreatedAt: "2023-11-27T21:37:13Z",
                                shopOrderFulfilledAt: "2023-11-27T21:37:28Z",
                                currencyCode: "DKK",
                                currencyCodeCustomer: "SEK",
                                shippingCost: 31.94,
                                shippingCostCustomer: 49,
                                totalAmount: 1557.15,
                                totalAmountCustomer: 2389,
                                totalDiscount: 0,
                                totalDiscountCustomer: 0,
                                conditionedDiscount: 0,
                                conditionedDiscountCustomer: 0,
                                amountPaidWithGiftCard: 0,
                                amountPaidWithGiftCardCustomer: 0,
                                taxesAmount: 311.43,
                                taxesAmountCustomer: 477.8,
                                customer: {
                                    id: 85281,
                                    email: "linus@turnr.se",
                                    riskScore: 50,
                                    blacklisted: false,
                                    firstName: "Linus",
                                    lastName: "Robertsson",
                                    riskLevel: "NORMAL",
                                    entityType: "CUSTOMER",
                                    workerInfo: {
                                        status: "READY",
                                        failedAttempts: 0,
                                    },
                                    entityId: 85281,
                                },
                                returns: null,
                                entityType: "ORDER",
                                workerInfo: {
                                    status: "READY",
                                    failedAttempts: 0,
                                },
                                entityId: 131913,
                            },
                            orderReturn: {
                                id: 133180,
                                returnStatus: "AWAITING_SHIPMENTS",
                                nextDelayCheckAt: "2023-11-28T21:40:39.435537Z",
                                createdAt: "2023-11-27T21:40:35.871418Z",
                                shipmentCarrier: "POSTNORD",
                                returnShipmentType: "PRINT_LABEL",
                                refundType: "BASIC",
                                exchangePolicy: "EXCHANGE_ON_RETURN",
                                priceListCurrencyCode: "SEK",
                                priceListExchangeCostType: "FREE",
                                numberOfItems: 3,
                                numberOfExchanges: 1,
                                exchangeVisualStatus: "PENDING",
                                numberOfComplaints: 0,
                                returnAddress: {
                                    id: 316855,
                                },
                                languageCode: "EN",
                                items: null,
                                shipments: null,
                                entityType: "RETURN",
                                workerInfo: {
                                    worker: "RETURN_SHIPMENTS_BOOKED_PROCESSOR",
                                    status: "READY",
                                    startedAt: "2023-11-27T21:40:48.792484Z",
                                    endedAt: "2023-11-27T21:40:49.552273Z",
                                    failedAttempts: 0,
                                },
                                entityId: 133180,
                            },
                            exchangeItems: null,
                            productVariant: {
                                id: 101072,
                                product: {
                                    id: 25158,
                                    type: "PRODUCT",
                                    title: "MOHAIR BEANIE",
                                    foreignId: "122",
                                    foreignProductNumber: "MOHAIR_BEANIE",
                                    imageSrc: "https://sandbox.centracdn.net/client/dynamic/images/122_002c64bf4e-ribbed-mohair-beanie-lilac.jpg",
                                    createdAt: "2023-11-24T09:55:14.695820Z",
                                    modifiedAt: "2023-11-27T18:54:27.344220Z",
                                    merchantBrand: {
                                        id: 626,
                                        name: "cos",
                                        shopType: "CENTRA",
                                        shopStatus: "ACTIVE",
                                        nextUpdateAt: "2023-11-28T18:54:07.985724Z",
                                        fontNamePrimary: "Inter",
                                        backgroundImage: "https://i.pinimg.com/originals/84/2a/d6/842ad68b315b0f586c30b465221da609.jpg",
                                        backgroundImageOpacity: 100,
                                        backgroundImageBlur: 3,
                                        logoSrc: "https://upload.wikimedia.org/wikipedia/commons/6/6e/COS_Logo.png",
                                        logoHeight: 24,
                                        colorPrimary: "#000000",
                                        colorSecondary: "#ededed",
                                        resaleTitlePostfix: "- Returned product",
                                        resaleTextPostfix:
                                            "This product will be shipped directly from another customer that has chosen to return the product. It is a good choice for the environment and as a bonus you get a discount!",
                                        orderIdText: "ORDER_NUMBER",
                                        displayName: "COS",
                                        htmlPageTitle: "COS Return Portal",
                                        htmlFavicon: "https://storage.googleapis.com/turnr-public/favicon-57%20(1).png",
                                        defaultLanguage: "EN",
                                        enabledLanguages: ["EN"],
                                        productsBundleMock: "COS",
                                        activePaymentPlan: {
                                            id: 585,
                                        },
                                        createdAt: "2023-11-16T16:46:06.590992Z",
                                        fontSizeBody: "14px",
                                        fontWeightBody: "normal",
                                        currency: "SEK",
                                        exchangePolicy: "EXCHANGE_ON_RETURN",
                                        roleSupportExchangeHandlingPermission: true,
                                        roleSupportRefundHandlingPermission: true,
                                        buttonType: "SHARP",
                                        inputType: "SHARP",
                                        checkboxType: "SHARP",
                                        windowType: "SHARP",
                                        overallType: "SHARP",
                                        riskSystemEnabled: false,
                                        riskSystemCustomerScoreWeight: 1,
                                        riskSystemOrderCapitalWeight: 1,
                                        riskSystemChainedOrdersWeight: 1,
                                        statistics: {
                                            TOTAL: {
                                                orders: 16,
                                                orderItems: 69,
                                                ordersWorth: 986892.45,
                                                returns: 12,
                                                returnsTurnr: 8,
                                                returnItems: 974,
                                                returnItemsWorth: 817122.39,
                                                returnItemsTurnr: 33,
                                                returnItemsTurnrWorth: 20805.69,
                                                exchangeItems: 9,
                                                exchangeItemsWorth: 4025.68,
                                                resalesAttempted: 0,
                                                resalesAttemptedWorth: 0,
                                                resalesCompleted: 0,
                                                resalesCompletedWorth: 0,
                                                complaintItems: 4,
                                                complaintItemsWorth: 3226.42,
                                                refundTransactions: 0,
                                                refundTransactionsWorth: 0,
                                                refundTransactionsTurnr: 0,
                                                refundTransactionsTurnrWorth: 0,
                                                giftCardsCreated: 0,
                                                giftCardsCreatedWorth: 0,
                                            },
                                            LAST_3_MONTHS: {
                                                orders: 16,
                                                orderItems: 69,
                                                ordersWorth: 986892.45,
                                                returns: 12,
                                                returnsTurnr: 8,
                                                returnItems: 974,
                                                returnItemsWorth: 817122.39,
                                                returnItemsTurnr: 33,
                                                returnItemsTurnrWorth: 20805.69,
                                                exchangeItems: 9,
                                                exchangeItemsWorth: 4025.68,
                                                resalesAttempted: 0,
                                                resalesAttemptedWorth: 0,
                                                resalesCompleted: 0,
                                                resalesCompletedWorth: 0,
                                                complaintItems: 4,
                                                complaintItemsWorth: 3226.42,
                                                refundTransactions: 0,
                                                refundTransactionsWorth: 0,
                                                refundTransactionsTurnr: 0,
                                                refundTransactionsTurnrWorth: 0,
                                                giftCardsCreated: 0,
                                                giftCardsCreatedWorth: 0,
                                            },
                                        },
                                        entityType: "SHOP",
                                        workerInfo: {
                                            worker: "SHOP_UPDATER",
                                            status: "READY",
                                            startedAt: "2023-11-27T18:54:06.955503Z",
                                            endedAt: "2023-11-27T18:54:07.985745Z",
                                            failedAttempts: 0,
                                        },
                                        entityId: 626,
                                    },
                                    isGiftCard: false,
                                    variantTypes: ["Variant", null],
                                    statistics: {
                                        id: 25158,
                                    },
                                    averagePrice: 450,
                                    averagePriceCurrency: "SEK",
                                    active: true,
                                    returnPolicy: "ALWAYS_ACCEPT",
                                    complaintPolicy: "ALWAYS_ACCEPT",
                                    exchangePolicy: "ALWAYS_ACCEPT",
                                    categories: [],
                                    entityType: "PRODUCT",
                                    workerInfo: {
                                        worker: "PRODUCT_DATA_UPDATER",
                                        status: "READY",
                                        startedAt: "2023-11-27T18:54:26.954871Z",
                                        endedAt: "2023-11-27T18:54:27.336212Z",
                                        failedAttempts: 0,
                                    },
                                    entityId: 25158,
                                },
                                title: "LILAC",
                                foreignId: "1619-703",
                                sku: "MOHAIR_BEANIELILAC",
                                imageSrc: "https://sandbox.centracdn.net/client/dynamic/images/122_002c64bf4e-ribbed-mohair-beanie-lilac.jpg",
                                merchantInventoryQuantity: 506,
                                createdAt: "2023-11-24T09:55:14.989481Z",
                                variantNumbers: ["LILAC", null],
                                variantTypeValues: ["LILAC", null],
                                fullName: "MOHAIR BEANIE LILAC",
                                statistics: {
                                    TOTAL: {
                                        orderItems: 7,
                                        returnItems: 7,
                                        returnRate: 1,
                                        exchangeItemsFrom: 3,
                                        exchangeItemsTo: 1,
                                        exchangeRate: 0.42857142857142855,
                                        complaintItems: 1,
                                        complaintRate: 0.14285714285714285,
                                    },
                                    LAST_3_MONTHS: {
                                        orderItems: 7,
                                        returnItems: 7,
                                        returnRate: 1,
                                        exchangeItemsFrom: 3,
                                        exchangeItemsTo: 1,
                                        exchangeRate: 0.42857142857142855,
                                        complaintItems: 1,
                                        complaintRate: 0.14285714285714285,
                                    },
                                },
                                entityType: "PRODUCT_VARIANT",
                                entityId: 101072,
                            },
                            orderItemStatus: "AWAITING_RETURN",
                            originalPriceAmount: 293.31,
                            originalPriceAmountCustomer: 450,
                            purchasePriceAmount: 293.31,
                            purchasePriceAmountCustomer: 450,
                            allocatedDiscount: 0,
                            allocatedDiscountCustomer: 0,
                            unitTaxesAmount: 58.66,
                            unitTaxesAmountCustomer: 90,
                            fulfillmentId: "322",
                            fulfillmentLineItemId: "739",
                            fulfilledAt: "2023-11-27T21:37:28Z",
                            returnReasons: null,
                            restockStatus: "NO_RESTOCK",
                            orderItemStatusOptions: ["AWAITING_RETURN", "IN_TRANSIT", "RETURNED", "LOST_IN_TRANSIT", "NOT_PICKED_UP"],
                            refundStatusOptions: ["NEW", "REFUNDED", "NO_REFUND"],
                            totalDiscountedPrice: 293.31,
                            totalDiscountedPriceCustomer: 450,
                            canBeRefunded: true,
                            entityType: "ORDER_ITEM",
                            entityId: 223375,
                        },
                        {
                            id: 223376,
                            foreignLineItemId: "1082",
                            order: {
                                id: 131913,
                                entityAddress: {
                                    id: 316854,
                                    street: "Testgatan 1",
                                    streetFull: "Testgatan 1",
                                    city: "Testcity",
                                    countryCode: "SE",
                                    zip: "111 11",
                                    firstName: "Linus",
                                    lastName: "Robertsson",
                                    fullName: "Linus Robertsson",
                                    email: "linus@turnr.se",
                                    phone: "0705320897",
                                    createdAt: "2023-11-27T21:40:35.860940Z",
                                },
                                merchantBrand: {
                                    id: 626,
                                    name: "cos",
                                    shopType: "CENTRA",
                                    shopStatus: "ACTIVE",
                                    nextUpdateAt: "2023-11-28T18:54:07.985724Z",
                                    fontNamePrimary: "Inter",
                                    backgroundImage: "https://i.pinimg.com/originals/84/2a/d6/842ad68b315b0f586c30b465221da609.jpg",
                                    backgroundImageOpacity: 100,
                                    backgroundImageBlur: 3,
                                    logoSrc: "https://upload.wikimedia.org/wikipedia/commons/6/6e/COS_Logo.png",
                                    logoHeight: 24,
                                    colorPrimary: "#000000",
                                    colorSecondary: "#ededed",
                                    resaleTitlePostfix: "- Returned product",
                                    resaleTextPostfix:
                                        "This product will be shipped directly from another customer that has chosen to return the product. It is a good choice for the environment and as a bonus you get a discount!",
                                    orderIdText: "ORDER_NUMBER",
                                    displayName: "COS",
                                    htmlPageTitle: "COS Return Portal",
                                    htmlFavicon: "https://storage.googleapis.com/turnr-public/favicon-57%20(1).png",
                                    defaultLanguage: "EN",
                                    enabledLanguages: ["EN"],
                                    productsBundleMock: "COS",
                                    activePaymentPlan: {
                                        id: 585,
                                    },
                                    createdAt: "2023-11-16T16:46:06.590992Z",
                                    fontSizeBody: "14px",
                                    fontWeightBody: "normal",
                                    currency: "SEK",
                                    exchangePolicy: "EXCHANGE_ON_RETURN",
                                    roleSupportExchangeHandlingPermission: true,
                                    roleSupportRefundHandlingPermission: true,
                                    buttonType: "SHARP",
                                    inputType: "SHARP",
                                    checkboxType: "SHARP",
                                    windowType: "SHARP",
                                    overallType: "SHARP",
                                    riskSystemEnabled: false,
                                    riskSystemCustomerScoreWeight: 1,
                                    riskSystemOrderCapitalWeight: 1,
                                    riskSystemChainedOrdersWeight: 1,
                                    statistics: {
                                        TOTAL: {
                                            orders: 16,
                                            orderItems: 69,
                                            ordersWorth: 986892.45,
                                            returns: 12,
                                            returnsTurnr: 8,
                                            returnItems: 974,
                                            returnItemsWorth: 817122.39,
                                            returnItemsTurnr: 33,
                                            returnItemsTurnrWorth: 20805.69,
                                            exchangeItems: 9,
                                            exchangeItemsWorth: 4025.68,
                                            resalesAttempted: 0,
                                            resalesAttemptedWorth: 0,
                                            resalesCompleted: 0,
                                            resalesCompletedWorth: 0,
                                            complaintItems: 4,
                                            complaintItemsWorth: 3226.42,
                                            refundTransactions: 0,
                                            refundTransactionsWorth: 0,
                                            refundTransactionsTurnr: 0,
                                            refundTransactionsTurnrWorth: 0,
                                            giftCardsCreated: 0,
                                            giftCardsCreatedWorth: 0,
                                        },
                                        LAST_3_MONTHS: {
                                            orders: 16,
                                            orderItems: 69,
                                            ordersWorth: 986892.45,
                                            returns: 12,
                                            returnsTurnr: 8,
                                            returnItems: 974,
                                            returnItemsWorth: 817122.39,
                                            returnItemsTurnr: 33,
                                            returnItemsTurnrWorth: 20805.69,
                                            exchangeItems: 9,
                                            exchangeItemsWorth: 4025.68,
                                            resalesAttempted: 0,
                                            resalesAttemptedWorth: 0,
                                            resalesCompleted: 0,
                                            resalesCompletedWorth: 0,
                                            complaintItems: 4,
                                            complaintItemsWorth: 3226.42,
                                            refundTransactions: 0,
                                            refundTransactionsWorth: 0,
                                            refundTransactionsTurnr: 0,
                                            refundTransactionsTurnrWorth: 0,
                                            giftCardsCreated: 0,
                                            giftCardsCreatedWorth: 0,
                                        },
                                    },
                                    entityType: "SHOP",
                                    workerInfo: {
                                        worker: "SHOP_UPDATER",
                                        status: "READY",
                                        startedAt: "2023-11-27T18:54:06.955503Z",
                                        endedAt: "2023-11-27T18:54:07.985745Z",
                                        failedAttempts: 0,
                                    },
                                    entityId: 626,
                                },
                                foreignId: "e2c7111336a18af4049adad7b1034330",
                                foreignNumber: 695,
                                foreignMarketId: "5-25",
                                createdAt: "2023-11-27T21:40:35.864454Z",
                                shopOrderCreatedAt: "2023-11-27T21:37:13Z",
                                shopOrderFulfilledAt: "2023-11-27T21:37:28Z",
                                currencyCode: "DKK",
                                currencyCodeCustomer: "SEK",
                                shippingCost: 31.94,
                                shippingCostCustomer: 49,
                                totalAmount: 1557.15,
                                totalAmountCustomer: 2389,
                                totalDiscount: 0,
                                totalDiscountCustomer: 0,
                                conditionedDiscount: 0,
                                conditionedDiscountCustomer: 0,
                                amountPaidWithGiftCard: 0,
                                amountPaidWithGiftCardCustomer: 0,
                                taxesAmount: 311.43,
                                taxesAmountCustomer: 477.8,
                                customer: {
                                    id: 85281,
                                    email: "linus@turnr.se",
                                    riskScore: 50,
                                    blacklisted: false,
                                    firstName: "Linus",
                                    lastName: "Robertsson",
                                    riskLevel: "NORMAL",
                                    entityType: "CUSTOMER",
                                    workerInfo: {
                                        status: "READY",
                                        failedAttempts: 0,
                                    },
                                    entityId: 85281,
                                },
                                returns: null,
                                entityType: "ORDER",
                                workerInfo: {
                                    status: "READY",
                                    failedAttempts: 0,
                                },
                                entityId: 131913,
                            },
                            orderReturn: {
                                id: 133180,
                                returnStatus: "AWAITING_SHIPMENTS",
                                nextDelayCheckAt: "2023-11-28T21:40:39.435537Z",
                                createdAt: "2023-11-27T21:40:35.871418Z",
                                shipmentCarrier: "POSTNORD",
                                returnShipmentType: "PRINT_LABEL",
                                refundType: "BASIC",
                                exchangePolicy: "EXCHANGE_ON_RETURN",
                                priceListCurrencyCode: "SEK",
                                priceListExchangeCostType: "FREE",
                                numberOfItems: 3,
                                numberOfExchanges: 1,
                                exchangeVisualStatus: "PENDING",
                                numberOfComplaints: 0,
                                returnAddress: {
                                    id: 316855,
                                },
                                languageCode: "EN",
                                items: null,
                                shipments: null,
                                entityType: "RETURN",
                                workerInfo: {
                                    worker: "RETURN_SHIPMENTS_BOOKED_PROCESSOR",
                                    status: "READY",
                                    startedAt: "2023-11-27T21:40:48.792484Z",
                                    endedAt: "2023-11-27T21:40:49.552273Z",
                                    failedAttempts: 0,
                                },
                                entityId: 133180,
                            },
                            exchangeItems: null,
                            productVariant: {
                                id: 101048,
                                product: {
                                    id: 25156,
                                    type: "PRODUCT",
                                    title: "LONG-SLEEVE TOP",
                                    foreignId: "120",
                                    foreignProductNumber: "LONG-SLEEVE_TOP",
                                    imageSrc: "https://sandbox.centracdn.net/client/dynamic/images/120_a963613cb3-slim-fit-long-sleeve-top-white.jpg",
                                    createdAt: "2023-11-24T09:55:13.703635Z",
                                    modifiedAt: "2023-11-27T18:54:11.996140Z",
                                    merchantBrand: {
                                        id: 626,
                                        name: "cos",
                                        shopType: "CENTRA",
                                        shopStatus: "ACTIVE",
                                        nextUpdateAt: "2023-11-28T18:54:07.985724Z",
                                        fontNamePrimary: "Inter",
                                        backgroundImage: "https://i.pinimg.com/originals/84/2a/d6/842ad68b315b0f586c30b465221da609.jpg",
                                        backgroundImageOpacity: 100,
                                        backgroundImageBlur: 3,
                                        logoSrc: "https://upload.wikimedia.org/wikipedia/commons/6/6e/COS_Logo.png",
                                        logoHeight: 24,
                                        colorPrimary: "#000000",
                                        colorSecondary: "#ededed",
                                        resaleTitlePostfix: "- Returned product",
                                        resaleTextPostfix:
                                            "This product will be shipped directly from another customer that has chosen to return the product. It is a good choice for the environment and as a bonus you get a discount!",
                                        orderIdText: "ORDER_NUMBER",
                                        displayName: "COS",
                                        htmlPageTitle: "COS Return Portal",
                                        htmlFavicon: "https://storage.googleapis.com/turnr-public/favicon-57%20(1).png",
                                        defaultLanguage: "EN",
                                        enabledLanguages: ["EN"],
                                        productsBundleMock: "COS",
                                        activePaymentPlan: {
                                            id: 585,
                                        },
                                        createdAt: "2023-11-16T16:46:06.590992Z",
                                        fontSizeBody: "14px",
                                        fontWeightBody: "normal",
                                        currency: "SEK",
                                        exchangePolicy: "EXCHANGE_ON_RETURN",
                                        roleSupportExchangeHandlingPermission: true,
                                        roleSupportRefundHandlingPermission: true,
                                        buttonType: "SHARP",
                                        inputType: "SHARP",
                                        checkboxType: "SHARP",
                                        windowType: "SHARP",
                                        overallType: "SHARP",
                                        riskSystemEnabled: false,
                                        riskSystemCustomerScoreWeight: 1,
                                        riskSystemOrderCapitalWeight: 1,
                                        riskSystemChainedOrdersWeight: 1,
                                        statistics: {
                                            TOTAL: {
                                                orders: 16,
                                                orderItems: 69,
                                                ordersWorth: 986892.45,
                                                returns: 12,
                                                returnsTurnr: 8,
                                                returnItems: 974,
                                                returnItemsWorth: 817122.39,
                                                returnItemsTurnr: 33,
                                                returnItemsTurnrWorth: 20805.69,
                                                exchangeItems: 9,
                                                exchangeItemsWorth: 4025.68,
                                                resalesAttempted: 0,
                                                resalesAttemptedWorth: 0,
                                                resalesCompleted: 0,
                                                resalesCompletedWorth: 0,
                                                complaintItems: 4,
                                                complaintItemsWorth: 3226.42,
                                                refundTransactions: 0,
                                                refundTransactionsWorth: 0,
                                                refundTransactionsTurnr: 0,
                                                refundTransactionsTurnrWorth: 0,
                                                giftCardsCreated: 0,
                                                giftCardsCreatedWorth: 0,
                                            },
                                            LAST_3_MONTHS: {
                                                orders: 16,
                                                orderItems: 69,
                                                ordersWorth: 986892.45,
                                                returns: 12,
                                                returnsTurnr: 8,
                                                returnItems: 974,
                                                returnItemsWorth: 817122.39,
                                                returnItemsTurnr: 33,
                                                returnItemsTurnrWorth: 20805.69,
                                                exchangeItems: 9,
                                                exchangeItemsWorth: 4025.68,
                                                resalesAttempted: 0,
                                                resalesAttemptedWorth: 0,
                                                resalesCompleted: 0,
                                                resalesCompletedWorth: 0,
                                                complaintItems: 4,
                                                complaintItemsWorth: 3226.42,
                                                refundTransactions: 0,
                                                refundTransactionsWorth: 0,
                                                refundTransactionsTurnr: 0,
                                                refundTransactionsTurnrWorth: 0,
                                                giftCardsCreated: 0,
                                                giftCardsCreatedWorth: 0,
                                            },
                                        },
                                        entityType: "SHOP",
                                        workerInfo: {
                                            worker: "SHOP_UPDATER",
                                            status: "READY",
                                            startedAt: "2023-11-27T18:54:06.955503Z",
                                            endedAt: "2023-11-27T18:54:07.985745Z",
                                            failedAttempts: 0,
                                        },
                                        entityId: 626,
                                    },
                                    isGiftCard: false,
                                    variantTypes: ["Variant", "Size"],
                                    statistics: {
                                        id: 25156,
                                    },
                                    averagePrice: 390,
                                    averagePriceCurrency: "SEK",
                                    active: true,
                                    returnPolicy: "ALWAYS_ACCEPT",
                                    complaintPolicy: "ALWAYS_ACCEPT",
                                    exchangePolicy: "ALWAYS_ACCEPT",
                                    categories: [],
                                    entityType: "PRODUCT",
                                    workerInfo: {
                                        worker: "PRODUCT_DATA_UPDATER",
                                        status: "READY",
                                        startedAt: "2023-11-27T18:54:11.430328Z",
                                        endedAt: "2023-11-27T18:54:11.958731Z",
                                        failedAttempts: 0,
                                    },
                                    entityId: 25156,
                                },
                                title: "BLACK S",
                                foreignId: "1611-679",
                                sku: "LONG-SLEEVE_TOP",
                                imageSrc: "https://sandbox.centracdn.net/client/dynamic/images/120_c70b75693f-slim-fit-long-sleeve-top-black.jpg",
                                merchantInventoryQuantity: 510,
                                createdAt: "2023-11-24T09:55:13.860371Z",
                                variantNumbers: [null, null],
                                variantTypeValues: ["BLACK", "S"],
                                fullName: "LONG-SLEEVE TOP BLACK S",
                                statistics: {
                                    TOTAL: {
                                        orderItems: 5,
                                        returnItems: 5,
                                        returnRate: 1,
                                        exchangeItemsFrom: 1,
                                        exchangeItemsTo: 0,
                                        exchangeRate: 0.2,
                                        complaintItems: 0,
                                        complaintRate: 0,
                                    },
                                    LAST_3_MONTHS: {
                                        orderItems: 5,
                                        returnItems: 5,
                                        returnRate: 1,
                                        exchangeItemsFrom: 1,
                                        exchangeItemsTo: 0,
                                        exchangeRate: 0.2,
                                        complaintItems: 0,
                                        complaintRate: 0,
                                    },
                                },
                                entityType: "PRODUCT_VARIANT",
                                entityId: 101048,
                            },
                            orderItemStatus: "AWAITING_RETURN",
                            originalPriceAmount: 254.2,
                            originalPriceAmountCustomer: 390,
                            purchasePriceAmount: 254.2,
                            purchasePriceAmountCustomer: 390,
                            allocatedDiscount: 0,
                            allocatedDiscountCustomer: 0,
                            unitTaxesAmount: 50.84,
                            unitTaxesAmountCustomer: 78,
                            fulfillmentId: "322",
                            fulfillmentLineItemId: "740",
                            fulfilledAt: "2023-11-27T21:37:28Z",
                            returnReasons: null,
                            refundStatus: "EXCHANGE_NO_REFUND",
                            restockStatus: "NO_RESTOCK",
                            orderItemStatusOptions: ["AWAITING_RETURN", "IN_TRANSIT", "RETURNED", "LOST_IN_TRANSIT", "NOT_PICKED_UP"],
                            refundStatusOptions: ["EXCHANGE_NO_REFUND"],
                            totalDiscountedPrice: 254.2,
                            totalDiscountedPriceCustomer: 390,
                            canBeRefunded: false,
                            entityType: "ORDER_ITEM",
                            entityId: 223376,
                        },
                        {
                            id: 223374,
                            foreignLineItemId: "1081",
                            order: {
                                id: 131913,
                                entityAddress: {
                                    id: 316854,
                                    street: "Testgatan 1",
                                    streetFull: "Testgatan 1",
                                    city: "Testcity",
                                    countryCode: "SE",
                                    zip: "111 11",
                                    firstName: "Linus",
                                    lastName: "Robertsson",
                                    fullName: "Linus Robertsson",
                                    email: "linus@turnr.se",
                                    phone: "0705320897",
                                    createdAt: "2023-11-27T21:40:35.860940Z",
                                },
                                merchantBrand: {
                                    id: 626,
                                    name: "cos",
                                    shopType: "CENTRA",
                                    shopStatus: "ACTIVE",
                                    nextUpdateAt: "2023-11-28T18:54:07.985724Z",
                                    fontNamePrimary: "Inter",
                                    backgroundImage: "https://i.pinimg.com/originals/84/2a/d6/842ad68b315b0f586c30b465221da609.jpg",
                                    backgroundImageOpacity: 100,
                                    backgroundImageBlur: 3,
                                    logoSrc: "https://upload.wikimedia.org/wikipedia/commons/6/6e/COS_Logo.png",
                                    logoHeight: 24,
                                    colorPrimary: "#000000",
                                    colorSecondary: "#ededed",
                                    resaleTitlePostfix: "- Returned product",
                                    resaleTextPostfix:
                                        "This product will be shipped directly from another customer that has chosen to return the product. It is a good choice for the environment and as a bonus you get a discount!",
                                    orderIdText: "ORDER_NUMBER",
                                    displayName: "COS",
                                    htmlPageTitle: "COS Return Portal",
                                    htmlFavicon: "https://storage.googleapis.com/turnr-public/favicon-57%20(1).png",
                                    defaultLanguage: "EN",
                                    enabledLanguages: ["EN"],
                                    productsBundleMock: "COS",
                                    activePaymentPlan: {
                                        id: 585,
                                    },
                                    createdAt: "2023-11-16T16:46:06.590992Z",
                                    fontSizeBody: "14px",
                                    fontWeightBody: "normal",
                                    currency: "SEK",
                                    exchangePolicy: "EXCHANGE_ON_RETURN",
                                    roleSupportExchangeHandlingPermission: true,
                                    roleSupportRefundHandlingPermission: true,
                                    buttonType: "SHARP",
                                    inputType: "SHARP",
                                    checkboxType: "SHARP",
                                    windowType: "SHARP",
                                    overallType: "SHARP",
                                    riskSystemEnabled: false,
                                    riskSystemCustomerScoreWeight: 1,
                                    riskSystemOrderCapitalWeight: 1,
                                    riskSystemChainedOrdersWeight: 1,
                                    statistics: {
                                        TOTAL: {
                                            orders: 16,
                                            orderItems: 69,
                                            ordersWorth: 986892.45,
                                            returns: 12,
                                            returnsTurnr: 8,
                                            returnItems: 974,
                                            returnItemsWorth: 817122.39,
                                            returnItemsTurnr: 33,
                                            returnItemsTurnrWorth: 20805.69,
                                            exchangeItems: 9,
                                            exchangeItemsWorth: 4025.68,
                                            resalesAttempted: 0,
                                            resalesAttemptedWorth: 0,
                                            resalesCompleted: 0,
                                            resalesCompletedWorth: 0,
                                            complaintItems: 4,
                                            complaintItemsWorth: 3226.42,
                                            refundTransactions: 0,
                                            refundTransactionsWorth: 0,
                                            refundTransactionsTurnr: 0,
                                            refundTransactionsTurnrWorth: 0,
                                            giftCardsCreated: 0,
                                            giftCardsCreatedWorth: 0,
                                        },
                                        LAST_3_MONTHS: {
                                            orders: 16,
                                            orderItems: 69,
                                            ordersWorth: 986892.45,
                                            returns: 12,
                                            returnsTurnr: 8,
                                            returnItems: 974,
                                            returnItemsWorth: 817122.39,
                                            returnItemsTurnr: 33,
                                            returnItemsTurnrWorth: 20805.69,
                                            exchangeItems: 9,
                                            exchangeItemsWorth: 4025.68,
                                            resalesAttempted: 0,
                                            resalesAttemptedWorth: 0,
                                            resalesCompleted: 0,
                                            resalesCompletedWorth: 0,
                                            complaintItems: 4,
                                            complaintItemsWorth: 3226.42,
                                            refundTransactions: 0,
                                            refundTransactionsWorth: 0,
                                            refundTransactionsTurnr: 0,
                                            refundTransactionsTurnrWorth: 0,
                                            giftCardsCreated: 0,
                                            giftCardsCreatedWorth: 0,
                                        },
                                    },
                                    entityType: "SHOP",
                                    workerInfo: {
                                        worker: "SHOP_UPDATER",
                                        status: "READY",
                                        startedAt: "2023-11-27T18:54:06.955503Z",
                                        endedAt: "2023-11-27T18:54:07.985745Z",
                                        failedAttempts: 0,
                                    },
                                    entityId: 626,
                                },
                                foreignId: "e2c7111336a18af4049adad7b1034330",
                                foreignNumber: 695,
                                foreignMarketId: "5-25",
                                createdAt: "2023-11-27T21:40:35.864454Z",
                                shopOrderCreatedAt: "2023-11-27T21:37:13Z",
                                shopOrderFulfilledAt: "2023-11-27T21:37:28Z",
                                currencyCode: "DKK",
                                currencyCodeCustomer: "SEK",
                                shippingCost: 31.94,
                                shippingCostCustomer: 49,
                                totalAmount: 1557.15,
                                totalAmountCustomer: 2389,
                                totalDiscount: 0,
                                totalDiscountCustomer: 0,
                                conditionedDiscount: 0,
                                conditionedDiscountCustomer: 0,
                                amountPaidWithGiftCard: 0,
                                amountPaidWithGiftCardCustomer: 0,
                                taxesAmount: 311.43,
                                taxesAmountCustomer: 477.8,
                                customer: {
                                    id: 85281,
                                    email: "linus@turnr.se",
                                    riskScore: 50,
                                    blacklisted: false,
                                    firstName: "Linus",
                                    lastName: "Robertsson",
                                    riskLevel: "NORMAL",
                                    entityType: "CUSTOMER",
                                    workerInfo: {
                                        status: "READY",
                                        failedAttempts: 0,
                                    },
                                    entityId: 85281,
                                },
                                returns: null,
                                entityType: "ORDER",
                                workerInfo: {
                                    status: "READY",
                                    failedAttempts: 0,
                                },
                                entityId: 131913,
                            },
                            orderReturn: {
                                id: 133180,
                                returnStatus: "AWAITING_SHIPMENTS",
                                nextDelayCheckAt: "2023-11-28T21:40:39.435537Z",
                                createdAt: "2023-11-27T21:40:35.871418Z",
                                shipmentCarrier: "POSTNORD",
                                returnShipmentType: "PRINT_LABEL",
                                refundType: "BASIC",
                                exchangePolicy: "EXCHANGE_ON_RETURN",
                                priceListCurrencyCode: "SEK",
                                priceListExchangeCostType: "FREE",
                                numberOfItems: 3,
                                numberOfExchanges: 1,
                                exchangeVisualStatus: "PENDING",
                                numberOfComplaints: 0,
                                returnAddress: {
                                    id: 316855,
                                },
                                languageCode: "EN",
                                items: null,
                                shipments: null,
                                entityType: "RETURN",
                                workerInfo: {
                                    worker: "RETURN_SHIPMENTS_BOOKED_PROCESSOR",
                                    status: "READY",
                                    startedAt: "2023-11-27T21:40:48.792484Z",
                                    endedAt: "2023-11-27T21:40:49.552273Z",
                                    failedAttempts: 0,
                                },
                                entityId: 133180,
                            },
                            exchangeItems: null,
                            productVariant: {
                                id: 100977,
                                product: {
                                    id: 25129,
                                    type: "PRODUCT",
                                    title: "BOXY JACKET",
                                    foreignId: "116",
                                    foreignProductNumber: "JACKET_BOXY",
                                    imageSrc: "https://sandbox.centracdn.net/client/dynamic/images/116_f927bab55d-boxy-double-faced-wool-jacket-light-grey.jpg",
                                    createdAt: "2023-11-23T16:46:35.737582Z",
                                    modifiedAt: "2023-11-27T18:54:09.047537Z",
                                    merchantBrand: {
                                        id: 626,
                                        name: "cos",
                                        shopType: "CENTRA",
                                        shopStatus: "ACTIVE",
                                        nextUpdateAt: "2023-11-28T18:54:07.985724Z",
                                        fontNamePrimary: "Inter",
                                        backgroundImage: "https://i.pinimg.com/originals/84/2a/d6/842ad68b315b0f586c30b465221da609.jpg",
                                        backgroundImageOpacity: 100,
                                        backgroundImageBlur: 3,
                                        logoSrc: "https://upload.wikimedia.org/wikipedia/commons/6/6e/COS_Logo.png",
                                        logoHeight: 24,
                                        colorPrimary: "#000000",
                                        colorSecondary: "#ededed",
                                        resaleTitlePostfix: "- Returned product",
                                        resaleTextPostfix:
                                            "This product will be shipped directly from another customer that has chosen to return the product. It is a good choice for the environment and as a bonus you get a discount!",
                                        orderIdText: "ORDER_NUMBER",
                                        displayName: "COS",
                                        htmlPageTitle: "COS Return Portal",
                                        htmlFavicon: "https://storage.googleapis.com/turnr-public/favicon-57%20(1).png",
                                        defaultLanguage: "EN",
                                        enabledLanguages: ["EN"],
                                        productsBundleMock: "COS",
                                        activePaymentPlan: {
                                            id: 585,
                                        },
                                        createdAt: "2023-11-16T16:46:06.590992Z",
                                        fontSizeBody: "14px",
                                        fontWeightBody: "normal",
                                        currency: "SEK",
                                        exchangePolicy: "EXCHANGE_ON_RETURN",
                                        roleSupportExchangeHandlingPermission: true,
                                        roleSupportRefundHandlingPermission: true,
                                        buttonType: "SHARP",
                                        inputType: "SHARP",
                                        checkboxType: "SHARP",
                                        windowType: "SHARP",
                                        overallType: "SHARP",
                                        riskSystemEnabled: false,
                                        riskSystemCustomerScoreWeight: 1,
                                        riskSystemOrderCapitalWeight: 1,
                                        riskSystemChainedOrdersWeight: 1,
                                        statistics: {
                                            TOTAL: {
                                                orders: 16,
                                                orderItems: 69,
                                                ordersWorth: 986892.45,
                                                returns: 12,
                                                returnsTurnr: 8,
                                                returnItems: 974,
                                                returnItemsWorth: 817122.39,
                                                returnItemsTurnr: 33,
                                                returnItemsTurnrWorth: 20805.69,
                                                exchangeItems: 9,
                                                exchangeItemsWorth: 4025.68,
                                                resalesAttempted: 0,
                                                resalesAttemptedWorth: 0,
                                                resalesCompleted: 0,
                                                resalesCompletedWorth: 0,
                                                complaintItems: 4,
                                                complaintItemsWorth: 3226.42,
                                                refundTransactions: 0,
                                                refundTransactionsWorth: 0,
                                                refundTransactionsTurnr: 0,
                                                refundTransactionsTurnrWorth: 0,
                                                giftCardsCreated: 0,
                                                giftCardsCreatedWorth: 0,
                                            },
                                            LAST_3_MONTHS: {
                                                orders: 16,
                                                orderItems: 69,
                                                ordersWorth: 986892.45,
                                                returns: 12,
                                                returnsTurnr: 8,
                                                returnItems: 974,
                                                returnItemsWorth: 817122.39,
                                                returnItemsTurnr: 33,
                                                returnItemsTurnrWorth: 20805.69,
                                                exchangeItems: 9,
                                                exchangeItemsWorth: 4025.68,
                                                resalesAttempted: 0,
                                                resalesAttemptedWorth: 0,
                                                resalesCompleted: 0,
                                                resalesCompletedWorth: 0,
                                                complaintItems: 4,
                                                complaintItemsWorth: 3226.42,
                                                refundTransactions: 0,
                                                refundTransactionsWorth: 0,
                                                refundTransactionsTurnr: 0,
                                                refundTransactionsTurnrWorth: 0,
                                                giftCardsCreated: 0,
                                                giftCardsCreatedWorth: 0,
                                            },
                                        },
                                        entityType: "SHOP",
                                        workerInfo: {
                                            worker: "SHOP_UPDATER",
                                            status: "READY",
                                            startedAt: "2023-11-27T18:54:06.955503Z",
                                            endedAt: "2023-11-27T18:54:07.985745Z",
                                            failedAttempts: 0,
                                        },
                                        entityId: 626,
                                    },
                                    isGiftCard: false,
                                    variantTypes: ["Variant", "Size"],
                                    statistics: {
                                        id: 25129,
                                    },
                                    averagePrice: 1500,
                                    averagePriceCurrency: "SEK",
                                    active: true,
                                    returnPolicy: "ALWAYS_ACCEPT",
                                    complaintPolicy: "ALWAYS_ACCEPT",
                                    exchangePolicy: "ALWAYS_ACCEPT",
                                    categories: [],
                                    entityType: "PRODUCT",
                                    workerInfo: {
                                        worker: "PRODUCT_DATA_UPDATER",
                                        status: "READY",
                                        startedAt: "2023-11-27T18:54:08.160348Z",
                                        endedAt: "2023-11-27T18:54:09.039453Z",
                                        failedAttempts: 0,
                                    },
                                    entityId: 25129,
                                },
                                title: "LIGHT GREY S",
                                foreignId: "1598-640",
                                sku: "JACKET_BOXY",
                                imageSrc: "https://sandbox.centracdn.net/client/dynamic/images/116_f927bab55d-boxy-double-faced-wool-jacket-light-grey.jpg",
                                merchantInventoryQuantity: 405,
                                createdAt: "2023-11-23T16:46:35.811759Z",
                                variantNumbers: [null, null],
                                variantTypeValues: ["LIGHT GREY", "S"],
                                fullName: "BOXY JACKET LIGHT GREY S",
                                statistics: {
                                    TOTAL: {
                                        orderItems: 109,
                                        returnItems: 104,
                                        returnRate: 0.9541284403669725,
                                        exchangeItemsFrom: 1,
                                        exchangeItemsTo: 1,
                                        exchangeRate: 0.009615384615384616,
                                        complaintItems: 1,
                                        complaintRate: 0.009615384615384616,
                                    },
                                    LAST_3_MONTHS: {
                                        orderItems: 109,
                                        returnItems: 104,
                                        returnRate: 0.9541284403669725,
                                        exchangeItemsFrom: 1,
                                        exchangeItemsTo: 1,
                                        exchangeRate: 0.009615384615384616,
                                        complaintItems: 1,
                                        complaintRate: 0.009615384615384616,
                                    },
                                },
                                entityType: "PRODUCT_VARIANT",
                                entityId: 100977,
                            },
                            orderItemStatus: "AWAITING_RETURN",
                            originalPriceAmount: 977.7,
                            originalPriceAmountCustomer: 1500,
                            purchasePriceAmount: 977.7,
                            purchasePriceAmountCustomer: 1500,
                            allocatedDiscount: 0,
                            allocatedDiscountCustomer: 0,
                            unitTaxesAmount: 195.54,
                            unitTaxesAmountCustomer: 300,
                            fulfillmentId: "322",
                            fulfillmentLineItemId: "741",
                            fulfilledAt: "2023-11-27T21:37:28Z",
                            returnReasons: null,
                            restockStatus: "NO_RESTOCK",
                            orderItemStatusOptions: ["AWAITING_RETURN", "IN_TRANSIT", "RETURNED", "LOST_IN_TRANSIT", "NOT_PICKED_UP"],
                            refundStatusOptions: ["NEW", "REFUNDED", "NO_REFUND"],
                            totalDiscountedPrice: 977.7,
                            totalDiscountedPriceCustomer: 1500,
                            canBeRefunded: true,
                            entityType: "ORDER_ITEM",
                            entityId: 223374,
                        },
                    ],
                    statusEvents: [
                        {
                            type: "ORDER_BOOKED",
                            status: "DONE",
                        },
                        {
                            type: "PACK_ITEMS_PRINT_LABEL",
                            status: "NOT_DONE",
                            qrCodeData: "RS40F3V8QGBOCGW1",
                            printDocuments: false,
                        },
                    ],
                },
            ],
            orderItems: [
                {
                    id: 223375,
                    foreignLineItemId: "1083",
                    order: {
                        id: 131913,
                        entityAddress: {
                            id: 316854,
                            street: "Testgatan 1",
                            streetFull: "Testgatan 1",
                            city: "Testcity",
                            countryCode: "SE",
                            zip: "111 11",
                            firstName: "Linus",
                            lastName: "Robertsson",
                            fullName: "Linus Robertsson",
                            email: "linus@turnr.se",
                            phone: "0705320897",
                            createdAt: "2023-11-27T21:40:35.860940Z",
                        },
                        merchantBrand: {
                            id: 626,
                            name: "cos",
                            shopType: "CENTRA",
                            shopStatus: "ACTIVE",
                            nextUpdateAt: "2023-11-28T18:54:07.985724Z",
                            fontNamePrimary: "Inter",
                            backgroundImage: "https://i.pinimg.com/originals/84/2a/d6/842ad68b315b0f586c30b465221da609.jpg",
                            backgroundImageOpacity: 100,
                            backgroundImageBlur: 3,
                            logoSrc: "https://upload.wikimedia.org/wikipedia/commons/6/6e/COS_Logo.png",
                            logoHeight: 24,
                            colorPrimary: "#000000",
                            colorSecondary: "#ededed",
                            resaleTitlePostfix: "- Returned product",
                            resaleTextPostfix:
                                "This product will be shipped directly from another customer that has chosen to return the product. It is a good choice for the environment and as a bonus you get a discount!",
                            orderIdText: "ORDER_NUMBER",
                            displayName: "COS",
                            htmlPageTitle: "COS Return Portal",
                            htmlFavicon: "https://storage.googleapis.com/turnr-public/favicon-57%20(1).png",
                            defaultLanguage: "EN",
                            enabledLanguages: ["EN"],
                            productsBundleMock: "COS",
                            activePaymentPlan: {
                                id: 585,
                            },
                            createdAt: "2023-11-16T16:46:06.590992Z",
                            fontSizeBody: "14px",
                            fontWeightBody: "normal",
                            currency: "SEK",
                            exchangePolicy: "EXCHANGE_ON_RETURN",
                            roleSupportExchangeHandlingPermission: true,
                            roleSupportRefundHandlingPermission: true,
                            buttonType: "SHARP",
                            inputType: "SHARP",
                            checkboxType: "SHARP",
                            windowType: "SHARP",
                            overallType: "SHARP",
                            riskSystemEnabled: false,
                            riskSystemCustomerScoreWeight: 1,
                            riskSystemOrderCapitalWeight: 1,
                            riskSystemChainedOrdersWeight: 1,
                            statistics: {
                                TOTAL: {
                                    orders: 16,
                                    orderItems: 69,
                                    ordersWorth: 986892.45,
                                    returns: 12,
                                    returnsTurnr: 8,
                                    returnItems: 974,
                                    returnItemsWorth: 817122.39,
                                    returnItemsTurnr: 33,
                                    returnItemsTurnrWorth: 20805.69,
                                    exchangeItems: 9,
                                    exchangeItemsWorth: 4025.68,
                                    resalesAttempted: 0,
                                    resalesAttemptedWorth: 0,
                                    resalesCompleted: 0,
                                    resalesCompletedWorth: 0,
                                    complaintItems: 4,
                                    complaintItemsWorth: 3226.42,
                                    refundTransactions: 0,
                                    refundTransactionsWorth: 0,
                                    refundTransactionsTurnr: 0,
                                    refundTransactionsTurnrWorth: 0,
                                    giftCardsCreated: 0,
                                    giftCardsCreatedWorth: 0,
                                },
                                LAST_3_MONTHS: {
                                    orders: 16,
                                    orderItems: 69,
                                    ordersWorth: 986892.45,
                                    returns: 12,
                                    returnsTurnr: 8,
                                    returnItems: 974,
                                    returnItemsWorth: 817122.39,
                                    returnItemsTurnr: 33,
                                    returnItemsTurnrWorth: 20805.69,
                                    exchangeItems: 9,
                                    exchangeItemsWorth: 4025.68,
                                    resalesAttempted: 0,
                                    resalesAttemptedWorth: 0,
                                    resalesCompleted: 0,
                                    resalesCompletedWorth: 0,
                                    complaintItems: 4,
                                    complaintItemsWorth: 3226.42,
                                    refundTransactions: 0,
                                    refundTransactionsWorth: 0,
                                    refundTransactionsTurnr: 0,
                                    refundTransactionsTurnrWorth: 0,
                                    giftCardsCreated: 0,
                                    giftCardsCreatedWorth: 0,
                                },
                            },
                            entityType: "SHOP",
                            workerInfo: {
                                worker: "SHOP_UPDATER",
                                status: "READY",
                                startedAt: "2023-11-27T18:54:06.955503Z",
                                endedAt: "2023-11-27T18:54:07.985745Z",
                                failedAttempts: 0,
                            },
                            entityId: 626,
                        },
                        foreignId: "e2c7111336a18af4049adad7b1034330",
                        foreignNumber: 695,
                        foreignMarketId: "5-25",
                        createdAt: "2023-11-27T21:40:35.864454Z",
                        shopOrderCreatedAt: "2023-11-27T21:37:13Z",
                        shopOrderFulfilledAt: "2023-11-27T21:37:28Z",
                        currencyCode: "DKK",
                        currencyCodeCustomer: "SEK",
                        shippingCost: 31.94,
                        shippingCostCustomer: 49,
                        totalAmount: 1557.15,
                        totalAmountCustomer: 2389,
                        totalDiscount: 0,
                        totalDiscountCustomer: 0,
                        conditionedDiscount: 0,
                        conditionedDiscountCustomer: 0,
                        amountPaidWithGiftCard: 0,
                        amountPaidWithGiftCardCustomer: 0,
                        taxesAmount: 311.43,
                        taxesAmountCustomer: 477.8,
                        customer: {
                            id: 85281,
                            email: "linus@turnr.se",
                            riskScore: 50,
                            blacklisted: false,
                            firstName: "Linus",
                            lastName: "Robertsson",
                            riskLevel: "NORMAL",
                            entityType: "CUSTOMER",
                            workerInfo: {
                                status: "READY",
                                failedAttempts: 0,
                            },
                            entityId: 85281,
                        },
                        returns: null,
                        entityType: "ORDER",
                        workerInfo: {
                            status: "READY",
                            failedAttempts: 0,
                        },
                        entityId: 131913,
                    },
                    orderReturn: {
                        id: 133180,
                        returnStatus: "AWAITING_SHIPMENTS",
                        nextDelayCheckAt: "2023-11-28T21:40:39.435537Z",
                        createdAt: "2023-11-27T21:40:35.871418Z",
                        shipmentCarrier: "POSTNORD",
                        returnShipmentType: "PRINT_LABEL",
                        refundType: "BASIC",
                        exchangePolicy: "EXCHANGE_ON_RETURN",
                        priceListCurrencyCode: "SEK",
                        priceListExchangeCostType: "FREE",
                        numberOfItems: 3,
                        numberOfExchanges: 1,
                        exchangeVisualStatus: "PENDING",
                        numberOfComplaints: 0,
                        returnAddress: {
                            id: 316855,
                        },
                        languageCode: "EN",
                        items: null,
                        shipments: null,
                        entityType: "RETURN",
                        workerInfo: {
                            worker: "RETURN_SHIPMENTS_BOOKED_PROCESSOR",
                            status: "READY",
                            startedAt: "2023-11-27T21:40:48.792484Z",
                            endedAt: "2023-11-27T21:40:49.552273Z",
                            failedAttempts: 0,
                        },
                        entityId: 133180,
                    },
                    exchangeItems: null,
                    productVariant: {
                        id: 101072,
                        product: {
                            id: 25158,
                            type: "PRODUCT",
                            title: "MOHAIR BEANIE",
                            foreignId: "122",
                            foreignProductNumber: "MOHAIR_BEANIE",
                            imageSrc: "https://sandbox.centracdn.net/client/dynamic/images/122_002c64bf4e-ribbed-mohair-beanie-lilac.jpg",
                            createdAt: "2023-11-24T09:55:14.695820Z",
                            modifiedAt: "2023-11-27T18:54:27.344220Z",
                            merchantBrand: {
                                id: 626,
                                name: "cos",
                                shopType: "CENTRA",
                                shopStatus: "ACTIVE",
                                nextUpdateAt: "2023-11-28T18:54:07.985724Z",
                                fontNamePrimary: "Inter",
                                backgroundImage: "https://i.pinimg.com/originals/84/2a/d6/842ad68b315b0f586c30b465221da609.jpg",
                                backgroundImageOpacity: 100,
                                backgroundImageBlur: 3,
                                logoSrc: "https://upload.wikimedia.org/wikipedia/commons/6/6e/COS_Logo.png",
                                logoHeight: 24,
                                colorPrimary: "#000000",
                                colorSecondary: "#ededed",
                                resaleTitlePostfix: "- Returned product",
                                resaleTextPostfix:
                                    "This product will be shipped directly from another customer that has chosen to return the product. It is a good choice for the environment and as a bonus you get a discount!",
                                orderIdText: "ORDER_NUMBER",
                                displayName: "COS",
                                htmlPageTitle: "COS Return Portal",
                                htmlFavicon: "https://storage.googleapis.com/turnr-public/favicon-57%20(1).png",
                                defaultLanguage: "EN",
                                enabledLanguages: ["EN"],
                                productsBundleMock: "COS",
                                activePaymentPlan: {
                                    id: 585,
                                },
                                createdAt: "2023-11-16T16:46:06.590992Z",
                                fontSizeBody: "14px",
                                fontWeightBody: "normal",
                                currency: "SEK",
                                exchangePolicy: "EXCHANGE_ON_RETURN",
                                roleSupportExchangeHandlingPermission: true,
                                roleSupportRefundHandlingPermission: true,
                                buttonType: "SHARP",
                                inputType: "SHARP",
                                checkboxType: "SHARP",
                                windowType: "SHARP",
                                overallType: "SHARP",
                                riskSystemEnabled: false,
                                riskSystemCustomerScoreWeight: 1,
                                riskSystemOrderCapitalWeight: 1,
                                riskSystemChainedOrdersWeight: 1,
                                statistics: {
                                    TOTAL: {
                                        orders: 16,
                                        orderItems: 69,
                                        ordersWorth: 986892.45,
                                        returns: 12,
                                        returnsTurnr: 8,
                                        returnItems: 974,
                                        returnItemsWorth: 817122.39,
                                        returnItemsTurnr: 33,
                                        returnItemsTurnrWorth: 20805.69,
                                        exchangeItems: 9,
                                        exchangeItemsWorth: 4025.68,
                                        resalesAttempted: 0,
                                        resalesAttemptedWorth: 0,
                                        resalesCompleted: 0,
                                        resalesCompletedWorth: 0,
                                        complaintItems: 4,
                                        complaintItemsWorth: 3226.42,
                                        refundTransactions: 0,
                                        refundTransactionsWorth: 0,
                                        refundTransactionsTurnr: 0,
                                        refundTransactionsTurnrWorth: 0,
                                        giftCardsCreated: 0,
                                        giftCardsCreatedWorth: 0,
                                    },
                                    LAST_3_MONTHS: {
                                        orders: 16,
                                        orderItems: 69,
                                        ordersWorth: 986892.45,
                                        returns: 12,
                                        returnsTurnr: 8,
                                        returnItems: 974,
                                        returnItemsWorth: 817122.39,
                                        returnItemsTurnr: 33,
                                        returnItemsTurnrWorth: 20805.69,
                                        exchangeItems: 9,
                                        exchangeItemsWorth: 4025.68,
                                        resalesAttempted: 0,
                                        resalesAttemptedWorth: 0,
                                        resalesCompleted: 0,
                                        resalesCompletedWorth: 0,
                                        complaintItems: 4,
                                        complaintItemsWorth: 3226.42,
                                        refundTransactions: 0,
                                        refundTransactionsWorth: 0,
                                        refundTransactionsTurnr: 0,
                                        refundTransactionsTurnrWorth: 0,
                                        giftCardsCreated: 0,
                                        giftCardsCreatedWorth: 0,
                                    },
                                },
                                entityType: "SHOP",
                                workerInfo: {
                                    worker: "SHOP_UPDATER",
                                    status: "READY",
                                    startedAt: "2023-11-27T18:54:06.955503Z",
                                    endedAt: "2023-11-27T18:54:07.985745Z",
                                    failedAttempts: 0,
                                },
                                entityId: 626,
                            },
                            isGiftCard: false,
                            variantTypes: ["Variant", null],
                            statistics: {
                                id: 25158,
                            },
                            averagePrice: 450,
                            averagePriceCurrency: "SEK",
                            active: true,
                            returnPolicy: "ALWAYS_ACCEPT",
                            complaintPolicy: "ALWAYS_ACCEPT",
                            exchangePolicy: "ALWAYS_ACCEPT",
                            categories: [],
                            entityType: "PRODUCT",
                            workerInfo: {
                                worker: "PRODUCT_DATA_UPDATER",
                                status: "READY",
                                startedAt: "2023-11-27T18:54:26.954871Z",
                                endedAt: "2023-11-27T18:54:27.336212Z",
                                failedAttempts: 0,
                            },
                            entityId: 25158,
                        },
                        title: "LILAC",
                        foreignId: "1619-703",
                        sku: "MOHAIR_BEANIELILAC",
                        imageSrc: "https://sandbox.centracdn.net/client/dynamic/images/122_002c64bf4e-ribbed-mohair-beanie-lilac.jpg",
                        merchantInventoryQuantity: 506,
                        createdAt: "2023-11-24T09:55:14.989481Z",
                        variantNumbers: ["LILAC", null],
                        variantTypeValues: ["LILAC", null],
                        fullName: "MOHAIR BEANIE LILAC",
                        statistics: {
                            TOTAL: {
                                orderItems: 7,
                                returnItems: 7,
                                returnRate: 1,
                                exchangeItemsFrom: 3,
                                exchangeItemsTo: 1,
                                exchangeRate: 0.42857142857142855,
                                complaintItems: 1,
                                complaintRate: 0.14285714285714285,
                            },
                            LAST_3_MONTHS: {
                                orderItems: 7,
                                returnItems: 7,
                                returnRate: 1,
                                exchangeItemsFrom: 3,
                                exchangeItemsTo: 1,
                                exchangeRate: 0.42857142857142855,
                                complaintItems: 1,
                                complaintRate: 0.14285714285714285,
                            },
                        },
                        entityType: "PRODUCT_VARIANT",
                        entityId: 101072,
                    },
                    orderItemStatus: "AWAITING_RETURN",
                    originalPriceAmount: 293.31,
                    originalPriceAmountCustomer: 450,
                    purchasePriceAmount: 293.31,
                    purchasePriceAmountCustomer: 450,
                    allocatedDiscount: 0,
                    allocatedDiscountCustomer: 0,
                    unitTaxesAmount: 58.66,
                    unitTaxesAmountCustomer: 90,
                    fulfillmentId: "322",
                    fulfillmentLineItemId: "739",
                    fulfilledAt: "2023-11-27T21:37:28Z",
                    returnReasons: null,
                    restockStatus: "NO_RESTOCK",
                    orderItemStatusOptions: ["AWAITING_RETURN", "IN_TRANSIT", "RETURNED", "LOST_IN_TRANSIT", "NOT_PICKED_UP"],
                    refundStatusOptions: ["NEW", "REFUNDED", "NO_REFUND"],
                    totalDiscountedPrice: 293.31,
                    totalDiscountedPriceCustomer: 450,
                    canBeRefunded: true,
                    entityType: "ORDER_ITEM",
                    entityId: 223375,
                },
                {
                    id: 223376,
                    foreignLineItemId: "1082",
                    order: {
                        id: 131913,
                        entityAddress: {
                            id: 316854,
                            street: "Testgatan 1",
                            streetFull: "Testgatan 1",
                            city: "Testcity",
                            countryCode: "SE",
                            zip: "111 11",
                            firstName: "Linus",
                            lastName: "Robertsson",
                            fullName: "Linus Robertsson",
                            email: "linus@turnr.se",
                            phone: "0705320897",
                            createdAt: "2023-11-27T21:40:35.860940Z",
                        },
                        merchantBrand: {
                            id: 626,
                            name: "cos",
                            shopType: "CENTRA",
                            shopStatus: "ACTIVE",
                            nextUpdateAt: "2023-11-28T18:54:07.985724Z",
                            fontNamePrimary: "Inter",
                            backgroundImage: "https://i.pinimg.com/originals/84/2a/d6/842ad68b315b0f586c30b465221da609.jpg",
                            backgroundImageOpacity: 100,
                            backgroundImageBlur: 3,
                            logoSrc: "https://upload.wikimedia.org/wikipedia/commons/6/6e/COS_Logo.png",
                            logoHeight: 24,
                            colorPrimary: "#000000",
                            colorSecondary: "#ededed",
                            resaleTitlePostfix: "- Returned product",
                            resaleTextPostfix:
                                "This product will be shipped directly from another customer that has chosen to return the product. It is a good choice for the environment and as a bonus you get a discount!",
                            orderIdText: "ORDER_NUMBER",
                            displayName: "COS",
                            htmlPageTitle: "COS Return Portal",
                            htmlFavicon: "https://storage.googleapis.com/turnr-public/favicon-57%20(1).png",
                            defaultLanguage: "EN",
                            enabledLanguages: ["EN"],
                            productsBundleMock: "COS",
                            activePaymentPlan: {
                                id: 585,
                            },
                            createdAt: "2023-11-16T16:46:06.590992Z",
                            fontSizeBody: "14px",
                            fontWeightBody: "normal",
                            currency: "SEK",
                            exchangePolicy: "EXCHANGE_ON_RETURN",
                            roleSupportExchangeHandlingPermission: true,
                            roleSupportRefundHandlingPermission: true,
                            buttonType: "SHARP",
                            inputType: "SHARP",
                            checkboxType: "SHARP",
                            windowType: "SHARP",
                            overallType: "SHARP",
                            riskSystemEnabled: false,
                            riskSystemCustomerScoreWeight: 1,
                            riskSystemOrderCapitalWeight: 1,
                            riskSystemChainedOrdersWeight: 1,
                            statistics: {
                                TOTAL: {
                                    orders: 16,
                                    orderItems: 69,
                                    ordersWorth: 986892.45,
                                    returns: 12,
                                    returnsTurnr: 8,
                                    returnItems: 974,
                                    returnItemsWorth: 817122.39,
                                    returnItemsTurnr: 33,
                                    returnItemsTurnrWorth: 20805.69,
                                    exchangeItems: 9,
                                    exchangeItemsWorth: 4025.68,
                                    resalesAttempted: 0,
                                    resalesAttemptedWorth: 0,
                                    resalesCompleted: 0,
                                    resalesCompletedWorth: 0,
                                    complaintItems: 4,
                                    complaintItemsWorth: 3226.42,
                                    refundTransactions: 0,
                                    refundTransactionsWorth: 0,
                                    refundTransactionsTurnr: 0,
                                    refundTransactionsTurnrWorth: 0,
                                    giftCardsCreated: 0,
                                    giftCardsCreatedWorth: 0,
                                },
                                LAST_3_MONTHS: {
                                    orders: 16,
                                    orderItems: 69,
                                    ordersWorth: 986892.45,
                                    returns: 12,
                                    returnsTurnr: 8,
                                    returnItems: 974,
                                    returnItemsWorth: 817122.39,
                                    returnItemsTurnr: 33,
                                    returnItemsTurnrWorth: 20805.69,
                                    exchangeItems: 9,
                                    exchangeItemsWorth: 4025.68,
                                    resalesAttempted: 0,
                                    resalesAttemptedWorth: 0,
                                    resalesCompleted: 0,
                                    resalesCompletedWorth: 0,
                                    complaintItems: 4,
                                    complaintItemsWorth: 3226.42,
                                    refundTransactions: 0,
                                    refundTransactionsWorth: 0,
                                    refundTransactionsTurnr: 0,
                                    refundTransactionsTurnrWorth: 0,
                                    giftCardsCreated: 0,
                                    giftCardsCreatedWorth: 0,
                                },
                            },
                            entityType: "SHOP",
                            workerInfo: {
                                worker: "SHOP_UPDATER",
                                status: "READY",
                                startedAt: "2023-11-27T18:54:06.955503Z",
                                endedAt: "2023-11-27T18:54:07.985745Z",
                                failedAttempts: 0,
                            },
                            entityId: 626,
                        },
                        foreignId: "e2c7111336a18af4049adad7b1034330",
                        foreignNumber: 695,
                        foreignMarketId: "5-25",
                        createdAt: "2023-11-27T21:40:35.864454Z",
                        shopOrderCreatedAt: "2023-11-27T21:37:13Z",
                        shopOrderFulfilledAt: "2023-11-27T21:37:28Z",
                        currencyCode: "DKK",
                        currencyCodeCustomer: "SEK",
                        shippingCost: 31.94,
                        shippingCostCustomer: 49,
                        totalAmount: 1557.15,
                        totalAmountCustomer: 2389,
                        totalDiscount: 0,
                        totalDiscountCustomer: 0,
                        conditionedDiscount: 0,
                        conditionedDiscountCustomer: 0,
                        amountPaidWithGiftCard: 0,
                        amountPaidWithGiftCardCustomer: 0,
                        taxesAmount: 311.43,
                        taxesAmountCustomer: 477.8,
                        customer: {
                            id: 85281,
                            email: "linus@turnr.se",
                            riskScore: 50,
                            blacklisted: false,
                            firstName: "Linus",
                            lastName: "Robertsson",
                            riskLevel: "NORMAL",
                            entityType: "CUSTOMER",
                            workerInfo: {
                                status: "READY",
                                failedAttempts: 0,
                            },
                            entityId: 85281,
                        },
                        returns: null,
                        entityType: "ORDER",
                        workerInfo: {
                            status: "READY",
                            failedAttempts: 0,
                        },
                        entityId: 131913,
                    },
                    orderReturn: {
                        id: 133180,
                        returnStatus: "AWAITING_SHIPMENTS",
                        nextDelayCheckAt: "2023-11-28T21:40:39.435537Z",
                        createdAt: "2023-11-27T21:40:35.871418Z",
                        shipmentCarrier: "POSTNORD",
                        returnShipmentType: "PRINT_LABEL",
                        refundType: "BASIC",
                        exchangePolicy: "EXCHANGE_ON_RETURN",
                        priceListCurrencyCode: "SEK",
                        priceListExchangeCostType: "FREE",
                        numberOfItems: 3,
                        numberOfExchanges: 1,
                        exchangeVisualStatus: "PENDING",
                        numberOfComplaints: 0,
                        returnAddress: {
                            id: 316855,
                        },
                        languageCode: "EN",
                        items: null,
                        shipments: null,
                        entityType: "RETURN",
                        workerInfo: {
                            worker: "RETURN_SHIPMENTS_BOOKED_PROCESSOR",
                            status: "READY",
                            startedAt: "2023-11-27T21:40:48.792484Z",
                            endedAt: "2023-11-27T21:40:49.552273Z",
                            failedAttempts: 0,
                        },
                        entityId: 133180,
                    },
                    exchangeItems: null,
                    productVariant: {
                        id: 101048,
                        product: {
                            id: 25156,
                            type: "PRODUCT",
                            title: "LONG-SLEEVE TOP",
                            foreignId: "120",
                            foreignProductNumber: "LONG-SLEEVE_TOP",
                            imageSrc: "https://sandbox.centracdn.net/client/dynamic/images/120_a963613cb3-slim-fit-long-sleeve-top-white.jpg",
                            createdAt: "2023-11-24T09:55:13.703635Z",
                            modifiedAt: "2023-11-27T18:54:11.996140Z",
                            merchantBrand: {
                                id: 626,
                                name: "cos",
                                shopType: "CENTRA",
                                shopStatus: "ACTIVE",
                                nextUpdateAt: "2023-11-28T18:54:07.985724Z",
                                fontNamePrimary: "Inter",
                                backgroundImage: "https://i.pinimg.com/originals/84/2a/d6/842ad68b315b0f586c30b465221da609.jpg",
                                backgroundImageOpacity: 100,
                                backgroundImageBlur: 3,
                                logoSrc: "https://upload.wikimedia.org/wikipedia/commons/6/6e/COS_Logo.png",
                                logoHeight: 24,
                                colorPrimary: "#000000",
                                colorSecondary: "#ededed",
                                resaleTitlePostfix: "- Returned product",
                                resaleTextPostfix:
                                    "This product will be shipped directly from another customer that has chosen to return the product. It is a good choice for the environment and as a bonus you get a discount!",
                                orderIdText: "ORDER_NUMBER",
                                displayName: "COS",
                                htmlPageTitle: "COS Return Portal",
                                htmlFavicon: "https://storage.googleapis.com/turnr-public/favicon-57%20(1).png",
                                defaultLanguage: "EN",
                                enabledLanguages: ["EN"],
                                productsBundleMock: "COS",
                                activePaymentPlan: {
                                    id: 585,
                                },
                                createdAt: "2023-11-16T16:46:06.590992Z",
                                fontSizeBody: "14px",
                                fontWeightBody: "normal",
                                currency: "SEK",
                                exchangePolicy: "EXCHANGE_ON_RETURN",
                                roleSupportExchangeHandlingPermission: true,
                                roleSupportRefundHandlingPermission: true,
                                buttonType: "SHARP",
                                inputType: "SHARP",
                                checkboxType: "SHARP",
                                windowType: "SHARP",
                                overallType: "SHARP",
                                riskSystemEnabled: false,
                                riskSystemCustomerScoreWeight: 1,
                                riskSystemOrderCapitalWeight: 1,
                                riskSystemChainedOrdersWeight: 1,
                                statistics: {
                                    TOTAL: {
                                        orders: 16,
                                        orderItems: 69,
                                        ordersWorth: 986892.45,
                                        returns: 12,
                                        returnsTurnr: 8,
                                        returnItems: 974,
                                        returnItemsWorth: 817122.39,
                                        returnItemsTurnr: 33,
                                        returnItemsTurnrWorth: 20805.69,
                                        exchangeItems: 9,
                                        exchangeItemsWorth: 4025.68,
                                        resalesAttempted: 0,
                                        resalesAttemptedWorth: 0,
                                        resalesCompleted: 0,
                                        resalesCompletedWorth: 0,
                                        complaintItems: 4,
                                        complaintItemsWorth: 3226.42,
                                        refundTransactions: 0,
                                        refundTransactionsWorth: 0,
                                        refundTransactionsTurnr: 0,
                                        refundTransactionsTurnrWorth: 0,
                                        giftCardsCreated: 0,
                                        giftCardsCreatedWorth: 0,
                                    },
                                    LAST_3_MONTHS: {
                                        orders: 16,
                                        orderItems: 69,
                                        ordersWorth: 986892.45,
                                        returns: 12,
                                        returnsTurnr: 8,
                                        returnItems: 974,
                                        returnItemsWorth: 817122.39,
                                        returnItemsTurnr: 33,
                                        returnItemsTurnrWorth: 20805.69,
                                        exchangeItems: 9,
                                        exchangeItemsWorth: 4025.68,
                                        resalesAttempted: 0,
                                        resalesAttemptedWorth: 0,
                                        resalesCompleted: 0,
                                        resalesCompletedWorth: 0,
                                        complaintItems: 4,
                                        complaintItemsWorth: 3226.42,
                                        refundTransactions: 0,
                                        refundTransactionsWorth: 0,
                                        refundTransactionsTurnr: 0,
                                        refundTransactionsTurnrWorth: 0,
                                        giftCardsCreated: 0,
                                        giftCardsCreatedWorth: 0,
                                    },
                                },
                                entityType: "SHOP",
                                workerInfo: {
                                    worker: "SHOP_UPDATER",
                                    status: "READY",
                                    startedAt: "2023-11-27T18:54:06.955503Z",
                                    endedAt: "2023-11-27T18:54:07.985745Z",
                                    failedAttempts: 0,
                                },
                                entityId: 626,
                            },
                            isGiftCard: false,
                            variantTypes: ["Variant", "Size"],
                            statistics: {
                                id: 25156,
                            },
                            averagePrice: 390,
                            averagePriceCurrency: "SEK",
                            active: true,
                            returnPolicy: "ALWAYS_ACCEPT",
                            complaintPolicy: "ALWAYS_ACCEPT",
                            exchangePolicy: "ALWAYS_ACCEPT",
                            categories: [],
                            entityType: "PRODUCT",
                            workerInfo: {
                                worker: "PRODUCT_DATA_UPDATER",
                                status: "READY",
                                startedAt: "2023-11-27T18:54:11.430328Z",
                                endedAt: "2023-11-27T18:54:11.958731Z",
                                failedAttempts: 0,
                            },
                            entityId: 25156,
                        },
                        title: "BLACK S",
                        foreignId: "1611-679",
                        sku: "LONG-SLEEVE_TOP",
                        imageSrc: "https://sandbox.centracdn.net/client/dynamic/images/120_c70b75693f-slim-fit-long-sleeve-top-black.jpg",
                        merchantInventoryQuantity: 510,
                        createdAt: "2023-11-24T09:55:13.860371Z",
                        variantNumbers: [null, null],
                        variantTypeValues: ["BLACK", "S"],
                        fullName: "LONG-SLEEVE TOP BLACK S",
                        statistics: {
                            TOTAL: {
                                orderItems: 5,
                                returnItems: 5,
                                returnRate: 1,
                                exchangeItemsFrom: 1,
                                exchangeItemsTo: 0,
                                exchangeRate: 0.2,
                                complaintItems: 0,
                                complaintRate: 0,
                            },
                            LAST_3_MONTHS: {
                                orderItems: 5,
                                returnItems: 5,
                                returnRate: 1,
                                exchangeItemsFrom: 1,
                                exchangeItemsTo: 0,
                                exchangeRate: 0.2,
                                complaintItems: 0,
                                complaintRate: 0,
                            },
                        },
                        entityType: "PRODUCT_VARIANT",
                        entityId: 101048,
                    },
                    orderItemStatus: "AWAITING_RETURN",
                    originalPriceAmount: 254.2,
                    originalPriceAmountCustomer: 390,
                    purchasePriceAmount: 254.2,
                    purchasePriceAmountCustomer: 390,
                    allocatedDiscount: 0,
                    allocatedDiscountCustomer: 0,
                    unitTaxesAmount: 50.84,
                    unitTaxesAmountCustomer: 78,
                    fulfillmentId: "322",
                    fulfillmentLineItemId: "740",
                    fulfilledAt: "2023-11-27T21:37:28Z",
                    returnReasons: null,
                    refundStatus: "EXCHANGE_NO_REFUND",
                    restockStatus: "NO_RESTOCK",
                    orderItemStatusOptions: ["AWAITING_RETURN", "IN_TRANSIT", "RETURNED", "LOST_IN_TRANSIT", "NOT_PICKED_UP"],
                    refundStatusOptions: ["EXCHANGE_NO_REFUND"],
                    totalDiscountedPrice: 254.2,
                    totalDiscountedPriceCustomer: 390,
                    canBeRefunded: false,
                    entityType: "ORDER_ITEM",
                    entityId: 223376,
                },
                {
                    id: 223374,
                    foreignLineItemId: "1081",
                    order: {
                        id: 131913,
                        entityAddress: {
                            id: 316854,
                            street: "Testgatan 1",
                            streetFull: "Testgatan 1",
                            city: "Testcity",
                            countryCode: "SE",
                            zip: "111 11",
                            firstName: "Linus",
                            lastName: "Robertsson",
                            fullName: "Linus Robertsson",
                            email: "linus@turnr.se",
                            phone: "0705320897",
                            createdAt: "2023-11-27T21:40:35.860940Z",
                        },
                        merchantBrand: {
                            id: 626,
                            name: "cos",
                            shopType: "CENTRA",
                            shopStatus: "ACTIVE",
                            nextUpdateAt: "2023-11-28T18:54:07.985724Z",
                            fontNamePrimary: "Inter",
                            backgroundImage: "https://i.pinimg.com/originals/84/2a/d6/842ad68b315b0f586c30b465221da609.jpg",
                            backgroundImageOpacity: 100,
                            backgroundImageBlur: 3,
                            logoSrc: "https://upload.wikimedia.org/wikipedia/commons/6/6e/COS_Logo.png",
                            logoHeight: 24,
                            colorPrimary: "#000000",
                            colorSecondary: "#ededed",
                            resaleTitlePostfix: "- Returned product",
                            resaleTextPostfix:
                                "This product will be shipped directly from another customer that has chosen to return the product. It is a good choice for the environment and as a bonus you get a discount!",
                            orderIdText: "ORDER_NUMBER",
                            displayName: "COS",
                            htmlPageTitle: "COS Return Portal",
                            htmlFavicon: "https://storage.googleapis.com/turnr-public/favicon-57%20(1).png",
                            defaultLanguage: "EN",
                            enabledLanguages: ["EN"],
                            productsBundleMock: "COS",
                            activePaymentPlan: {
                                id: 585,
                            },
                            createdAt: "2023-11-16T16:46:06.590992Z",
                            fontSizeBody: "14px",
                            fontWeightBody: "normal",
                            currency: "SEK",
                            exchangePolicy: "EXCHANGE_ON_RETURN",
                            roleSupportExchangeHandlingPermission: true,
                            roleSupportRefundHandlingPermission: true,
                            buttonType: "SHARP",
                            inputType: "SHARP",
                            checkboxType: "SHARP",
                            windowType: "SHARP",
                            overallType: "SHARP",
                            riskSystemEnabled: false,
                            riskSystemCustomerScoreWeight: 1,
                            riskSystemOrderCapitalWeight: 1,
                            riskSystemChainedOrdersWeight: 1,
                            statistics: {
                                TOTAL: {
                                    orders: 16,
                                    orderItems: 69,
                                    ordersWorth: 986892.45,
                                    returns: 12,
                                    returnsTurnr: 8,
                                    returnItems: 974,
                                    returnItemsWorth: 817122.39,
                                    returnItemsTurnr: 33,
                                    returnItemsTurnrWorth: 20805.69,
                                    exchangeItems: 9,
                                    exchangeItemsWorth: 4025.68,
                                    resalesAttempted: 0,
                                    resalesAttemptedWorth: 0,
                                    resalesCompleted: 0,
                                    resalesCompletedWorth: 0,
                                    complaintItems: 4,
                                    complaintItemsWorth: 3226.42,
                                    refundTransactions: 0,
                                    refundTransactionsWorth: 0,
                                    refundTransactionsTurnr: 0,
                                    refundTransactionsTurnrWorth: 0,
                                    giftCardsCreated: 0,
                                    giftCardsCreatedWorth: 0,
                                },
                                LAST_3_MONTHS: {
                                    orders: 16,
                                    orderItems: 69,
                                    ordersWorth: 986892.45,
                                    returns: 12,
                                    returnsTurnr: 8,
                                    returnItems: 974,
                                    returnItemsWorth: 817122.39,
                                    returnItemsTurnr: 33,
                                    returnItemsTurnrWorth: 20805.69,
                                    exchangeItems: 9,
                                    exchangeItemsWorth: 4025.68,
                                    resalesAttempted: 0,
                                    resalesAttemptedWorth: 0,
                                    resalesCompleted: 0,
                                    resalesCompletedWorth: 0,
                                    complaintItems: 4,
                                    complaintItemsWorth: 3226.42,
                                    refundTransactions: 0,
                                    refundTransactionsWorth: 0,
                                    refundTransactionsTurnr: 0,
                                    refundTransactionsTurnrWorth: 0,
                                    giftCardsCreated: 0,
                                    giftCardsCreatedWorth: 0,
                                },
                            },
                            entityType: "SHOP",
                            workerInfo: {
                                worker: "SHOP_UPDATER",
                                status: "READY",
                                startedAt: "2023-11-27T18:54:06.955503Z",
                                endedAt: "2023-11-27T18:54:07.985745Z",
                                failedAttempts: 0,
                            },
                            entityId: 626,
                        },
                        foreignId: "e2c7111336a18af4049adad7b1034330",
                        foreignNumber: 695,
                        foreignMarketId: "5-25",
                        createdAt: "2023-11-27T21:40:35.864454Z",
                        shopOrderCreatedAt: "2023-11-27T21:37:13Z",
                        shopOrderFulfilledAt: "2023-11-27T21:37:28Z",
                        currencyCode: "DKK",
                        currencyCodeCustomer: "SEK",
                        shippingCost: 31.94,
                        shippingCostCustomer: 49,
                        totalAmount: 1557.15,
                        totalAmountCustomer: 2389,
                        totalDiscount: 0,
                        totalDiscountCustomer: 0,
                        conditionedDiscount: 0,
                        conditionedDiscountCustomer: 0,
                        amountPaidWithGiftCard: 0,
                        amountPaidWithGiftCardCustomer: 0,
                        taxesAmount: 311.43,
                        taxesAmountCustomer: 477.8,
                        customer: {
                            id: 85281,
                            email: "linus@turnr.se",
                            riskScore: 50,
                            blacklisted: false,
                            firstName: "Linus",
                            lastName: "Robertsson",
                            riskLevel: "NORMAL",
                            entityType: "CUSTOMER",
                            workerInfo: {
                                status: "READY",
                                failedAttempts: 0,
                            },
                            entityId: 85281,
                        },
                        returns: null,
                        entityType: "ORDER",
                        workerInfo: {
                            status: "READY",
                            failedAttempts: 0,
                        },
                        entityId: 131913,
                    },
                    orderReturn: {
                        id: 133180,
                        returnStatus: "AWAITING_SHIPMENTS",
                        nextDelayCheckAt: "2023-11-28T21:40:39.435537Z",
                        createdAt: "2023-11-27T21:40:35.871418Z",
                        shipmentCarrier: "POSTNORD",
                        returnShipmentType: "PRINT_LABEL",
                        refundType: "BASIC",
                        exchangePolicy: "EXCHANGE_ON_RETURN",
                        priceListCurrencyCode: "SEK",
                        priceListExchangeCostType: "FREE",
                        numberOfItems: 3,
                        numberOfExchanges: 1,
                        exchangeVisualStatus: "PENDING",
                        numberOfComplaints: 0,
                        returnAddress: {
                            id: 316855,
                        },
                        languageCode: "EN",
                        items: null,
                        shipments: null,
                        entityType: "RETURN",
                        workerInfo: {
                            worker: "RETURN_SHIPMENTS_BOOKED_PROCESSOR",
                            status: "READY",
                            startedAt: "2023-11-27T21:40:48.792484Z",
                            endedAt: "2023-11-27T21:40:49.552273Z",
                            failedAttempts: 0,
                        },
                        entityId: 133180,
                    },
                    exchangeItems: null,
                    productVariant: {
                        id: 100977,
                        product: {
                            id: 25129,
                            type: "PRODUCT",
                            title: "BOXY JACKET",
                            foreignId: "116",
                            foreignProductNumber: "JACKET_BOXY",
                            imageSrc: "https://sandbox.centracdn.net/client/dynamic/images/116_f927bab55d-boxy-double-faced-wool-jacket-light-grey.jpg",
                            createdAt: "2023-11-23T16:46:35.737582Z",
                            modifiedAt: "2023-11-27T18:54:09.047537Z",
                            merchantBrand: {
                                id: 626,
                                name: "cos",
                                shopType: "CENTRA",
                                shopStatus: "ACTIVE",
                                nextUpdateAt: "2023-11-28T18:54:07.985724Z",
                                fontNamePrimary: "Inter",
                                backgroundImage: "https://i.pinimg.com/originals/84/2a/d6/842ad68b315b0f586c30b465221da609.jpg",
                                backgroundImageOpacity: 100,
                                backgroundImageBlur: 3,
                                logoSrc: "https://upload.wikimedia.org/wikipedia/commons/6/6e/COS_Logo.png",
                                logoHeight: 24,
                                colorPrimary: "#000000",
                                colorSecondary: "#ededed",
                                resaleTitlePostfix: "- Returned product",
                                resaleTextPostfix:
                                    "This product will be shipped directly from another customer that has chosen to return the product. It is a good choice for the environment and as a bonus you get a discount!",
                                orderIdText: "ORDER_NUMBER",
                                displayName: "COS",
                                htmlPageTitle: "COS Return Portal",
                                htmlFavicon: "https://storage.googleapis.com/turnr-public/favicon-57%20(1).png",
                                defaultLanguage: "EN",
                                enabledLanguages: ["EN"],
                                productsBundleMock: "COS",
                                activePaymentPlan: {
                                    id: 585,
                                },
                                createdAt: "2023-11-16T16:46:06.590992Z",
                                fontSizeBody: "14px",
                                fontWeightBody: "normal",
                                currency: "SEK",
                                exchangePolicy: "EXCHANGE_ON_RETURN",
                                roleSupportExchangeHandlingPermission: true,
                                roleSupportRefundHandlingPermission: true,
                                buttonType: "SHARP",
                                inputType: "SHARP",
                                checkboxType: "SHARP",
                                windowType: "SHARP",
                                overallType: "SHARP",
                                riskSystemEnabled: false,
                                riskSystemCustomerScoreWeight: 1,
                                riskSystemOrderCapitalWeight: 1,
                                riskSystemChainedOrdersWeight: 1,
                                statistics: {
                                    TOTAL: {
                                        orders: 16,
                                        orderItems: 69,
                                        ordersWorth: 986892.45,
                                        returns: 12,
                                        returnsTurnr: 8,
                                        returnItems: 974,
                                        returnItemsWorth: 817122.39,
                                        returnItemsTurnr: 33,
                                        returnItemsTurnrWorth: 20805.69,
                                        exchangeItems: 9,
                                        exchangeItemsWorth: 4025.68,
                                        resalesAttempted: 0,
                                        resalesAttemptedWorth: 0,
                                        resalesCompleted: 0,
                                        resalesCompletedWorth: 0,
                                        complaintItems: 4,
                                        complaintItemsWorth: 3226.42,
                                        refundTransactions: 0,
                                        refundTransactionsWorth: 0,
                                        refundTransactionsTurnr: 0,
                                        refundTransactionsTurnrWorth: 0,
                                        giftCardsCreated: 0,
                                        giftCardsCreatedWorth: 0,
                                    },
                                    LAST_3_MONTHS: {
                                        orders: 16,
                                        orderItems: 69,
                                        ordersWorth: 986892.45,
                                        returns: 12,
                                        returnsTurnr: 8,
                                        returnItems: 974,
                                        returnItemsWorth: 817122.39,
                                        returnItemsTurnr: 33,
                                        returnItemsTurnrWorth: 20805.69,
                                        exchangeItems: 9,
                                        exchangeItemsWorth: 4025.68,
                                        resalesAttempted: 0,
                                        resalesAttemptedWorth: 0,
                                        resalesCompleted: 0,
                                        resalesCompletedWorth: 0,
                                        complaintItems: 4,
                                        complaintItemsWorth: 3226.42,
                                        refundTransactions: 0,
                                        refundTransactionsWorth: 0,
                                        refundTransactionsTurnr: 0,
                                        refundTransactionsTurnrWorth: 0,
                                        giftCardsCreated: 0,
                                        giftCardsCreatedWorth: 0,
                                    },
                                },
                                entityType: "SHOP",
                                workerInfo: {
                                    worker: "SHOP_UPDATER",
                                    status: "READY",
                                    startedAt: "2023-11-27T18:54:06.955503Z",
                                    endedAt: "2023-11-27T18:54:07.985745Z",
                                    failedAttempts: 0,
                                },
                                entityId: 626,
                            },
                            isGiftCard: false,
                            variantTypes: ["Variant", "Size"],
                            statistics: {
                                id: 25129,
                            },
                            averagePrice: 1500,
                            averagePriceCurrency: "SEK",
                            active: true,
                            returnPolicy: "ALWAYS_ACCEPT",
                            complaintPolicy: "ALWAYS_ACCEPT",
                            exchangePolicy: "ALWAYS_ACCEPT",
                            categories: [],
                            entityType: "PRODUCT",
                            workerInfo: {
                                worker: "PRODUCT_DATA_UPDATER",
                                status: "READY",
                                startedAt: "2023-11-27T18:54:08.160348Z",
                                endedAt: "2023-11-27T18:54:09.039453Z",
                                failedAttempts: 0,
                            },
                            entityId: 25129,
                        },
                        title: "LIGHT GREY S",
                        foreignId: "1598-640",
                        sku: "JACKET_BOXY",
                        imageSrc: "https://sandbox.centracdn.net/client/dynamic/images/116_f927bab55d-boxy-double-faced-wool-jacket-light-grey.jpg",
                        merchantInventoryQuantity: 405,
                        createdAt: "2023-11-23T16:46:35.811759Z",
                        variantNumbers: [null, null],
                        variantTypeValues: ["LIGHT GREY", "S"],
                        fullName: "BOXY JACKET LIGHT GREY S",
                        statistics: {
                            TOTAL: {
                                orderItems: 109,
                                returnItems: 104,
                                returnRate: 0.9541284403669725,
                                exchangeItemsFrom: 1,
                                exchangeItemsTo: 1,
                                exchangeRate: 0.009615384615384616,
                                complaintItems: 1,
                                complaintRate: 0.009615384615384616,
                            },
                            LAST_3_MONTHS: {
                                orderItems: 109,
                                returnItems: 104,
                                returnRate: 0.9541284403669725,
                                exchangeItemsFrom: 1,
                                exchangeItemsTo: 1,
                                exchangeRate: 0.009615384615384616,
                                complaintItems: 1,
                                complaintRate: 0.009615384615384616,
                            },
                        },
                        entityType: "PRODUCT_VARIANT",
                        entityId: 100977,
                    },
                    orderItemStatus: "AWAITING_RETURN",
                    originalPriceAmount: 977.7,
                    originalPriceAmountCustomer: 1500,
                    purchasePriceAmount: 977.7,
                    purchasePriceAmountCustomer: 1500,
                    allocatedDiscount: 0,
                    allocatedDiscountCustomer: 0,
                    unitTaxesAmount: 195.54,
                    unitTaxesAmountCustomer: 300,
                    fulfillmentId: "322",
                    fulfillmentLineItemId: "741",
                    fulfilledAt: "2023-11-27T21:37:28Z",
                    returnReasons: null,
                    restockStatus: "NO_RESTOCK",
                    orderItemStatusOptions: ["AWAITING_RETURN", "IN_TRANSIT", "RETURNED", "LOST_IN_TRANSIT", "NOT_PICKED_UP"],
                    refundStatusOptions: ["NEW", "REFUNDED", "NO_REFUND"],
                    totalDiscountedPrice: 977.7,
                    totalDiscountedPriceCustomer: 1500,
                    canBeRefunded: true,
                    entityType: "ORDER_ITEM",
                    entityId: 223374,
                },
            ],
            statusEvents: [
                {
                    type: "ORDER_BOOKED",
                    status: "DONE",
                },
                {
                    type: "PACK_ITEMS_PRINT_LABEL",
                    status: "NOT_DONE",
                    qrCodeData: "RS40F3V8QGBOCGW1",
                    printDocuments: false,
                },
            ],
        };
    }

    return defaultMock;
}
